/**
 * Traductions FR / DE pour la page d'accueil.
 *
 * Utilisez l'objet `translations[lang]` via le hook `useLang().t('path.to.key')`.
 * Les valeurs avec `pre`/`em`/`post` permettent de séparer la partie en italique
 * (rendue avec un <em> stylisé) du reste du titre.
 */

export const translations = {
  // ─── FR ─────────────────────────────────────────────────────────────
  fr: {
    language: {
      label: 'Langue',
      fr: 'Français',
      de: 'Deutsch',
    },
    languagePopup: {
      title: 'Choisissez votre langue',
      subtitle: 'Bitte wählen Sie Ihre Sprache.',
      french: 'Français',
      german: 'Deutsch',
      continue: 'Continuer',
    },

    logos: {
      label: 'Technologies et plateformes maîtrisées',
    },

    hero: {
      titlePre: 'Transformez Votre',
      titleEm: 'Vision Digitale',
      titlePost: 'En Réalité avec Nexia',
      desc: "Nexia Digital, agence digitale à Paris et en Île-de-France, vous accompagne dans la création de sites web performants, le développement d'applications mobiles, le design graphique, le community management et les stratégies de marketing digital pour booster votre visibilité et obtenir des résultats mesurables.",
      ctaPrimary: 'Démarrer un Projet',
      ctaSecondary: 'Voir Portfolio',
      proof: {
        p1Value: 'Full-Service', p1Label: 'Agence digitale',
        p2Value: 'IA-Native',    p2Label: 'Solutions intégrées',
        p3Value: 'Sur-Mesure',   p3Label: 'Chaque projet',
        p4Value: '24h',          p4Label: 'Délai réponse',
      },
    },

    aboutMini: {
      eyebrow: 'À Propos de Nexia Digital',
      titlePre: "L'Agence Digitale Qui",
      titleEm: 'Fait la Différence',
      p1: "Fondée par des passionnés du numérique, Nexia Digital est une agence de communication digitale à Paris, spécialisée dans la création de sites web, le SEO, le marketing digital et le branding. Notre mission est d'accompagner les entreprises dans leur transformation digitale avec créativité, expertise et un engagement.",
      p2: 'Agence web ambitieuse, nous mettons notre passion et notre savoir-faire au service de votre croissance digitale avec des solutions sur mesure, créatives et orientées résultats.',
      point1: 'Équipe pluridisciplinaire de plus de 15 experts à votre écoute',
      point2: 'Approche agile et méthodologie éprouvée',
      point3: 'Reporting transparent et suivi régulier de vos KPIs',
      point4: 'Support technique disponible 7j/7',
      cta: 'En savoir plus',
      value1Title: 'Orienté Résultats',
      value1Desc:  'Chaque action est mesurée et optimisée pour maximiser votre ROI.',
      value2Title: 'Innovation Continue',
      value2Desc:  'Nous intégrons les dernières technologies et tendances digitales.',
      value3Title: 'Partenariat Durable',
      value3Desc:  'Nous construisons des relations sur le long terme avec nos clients.',
      value4Title: 'Réactivité',
      value4Desc:  'Une équipe disponible et proactive pour répondre à vos besoins.',
      badgeNumber: '100%',
      badgeStrong: 'Clients Satisfaits',
      badgeText:   'Au service de votre croissance digitale',
    },

    youtube: {
      eyebrow: 'Notre Vision',
      titlePre: 'Découvrez',
      titleEm: 'Nexia Digital',
      titlePost: 'en vidéo',
      desc: "Une agence pensée pour propulser votre marque dans l'ère digitale.",
      approach1Title: 'Créativité',  approach1Desc: 'Des idées qui sortent du lot',
      approach2Title: 'Technologie', approach2Desc: 'Des outils performants & modernes',
      approach3Title: 'Data-driven', approach3Desc: 'Décisions fondées sur la data',
      approach4Title: 'Croissance',  approach4Desc: 'Propulser votre marque',
    },

    services: {
      eyebrow: 'Nos Expertises',
      titlePre: 'Des solutions',
      titleEm: 'sur-mesure',
      titlePost: 'pour votre business',
      desc: 'De la stratégie à la mise en œuvre, nous couvrons toutes les expertises digitales.',

      // ── Page /services (listing) ───────────────────────
      pageEyebrow: 'Nos Expertises',
      pageTitlePre: 'Un Écosystème Complet',
      pageTitleEm: 'de Services Digitaux',
      pageDesc: "Que vous ayez besoin d'une présence web, d'une identité visuelle forte, d'une stratégie social media ou d'une campagne publicitaire percutante — Nexia Digital est votre partenaire tout-en-un.",
      learnMore: 'En savoir plus',
      discover: 'Découvrir',
      seeAll: 'Voir tous nos services',

      // SEO (page /services)
      seoTitle: 'Nos Services — Nexia Digital | Agence Digitale',
      seoDesc: 'Découvrez tous les services de Nexia Digital : développement web & mobile, graphisme, community management, motion design, marketing digital et consulting.',
      seoKeywords: 'services agence digitale, développement web, graphisme, community management, motion design, SEO, marketing digital',

      // ── ServiceDetail (page /services/:slug) ──
      detail: {
        breadcrumbHome: 'Accueil',
        breadcrumbServices: 'Services',
        ctaQuote: 'Obtenir un Devis',
        whyChoosePre: 'Pourquoi Choisir Nexia Digital pour',
        whyChooseSuffix: '?',
        teamLine: "Notre équipe d'experts combine créativité, expertise technique et une compréhension approfondie de vos besoins pour vous livrer des solutions qui génèrent de vrais résultats. Chaque projet est unique, chaque stratégie est sur mesure.",
        deliveryTitle: 'Ce Que Nous Livrons',
        processTitle: 'Notre Processus',
        step1Title: 'Découverte',
        step1Desc:  'Analyse de vos besoins, objectifs et contexte concurrentiel.',
        step2Title: 'Stratégie',
        step2Desc:  "Élaboration d'une approche sur mesure et d'un plan d'action détaillé.",
        step3Title: 'Création',
        step3Desc:  "Production par notre équipe d'experts avec suivi rigoureux.",
        step4Title: 'Livraison',
        step4Desc:  'Déploiement, formation et accompagnement post-lancement.',
        sidebarTitle: 'Démarrer Votre Projet',
        sidebarDesc:  'Obtenez un devis personnalisé gratuit sous 24h. Notre équipe analyse vos besoins et vous propose une solution adaptée.',
        sidebarCta1:  'Demander un Devis',
        sidebarCta2:  'Nous Contacter',
        sidebarInfo3: 'Réponse en moins de 24h',
        keywordsTitle: 'Mots-Clés',
        otherTitlePre: 'Nos Autres',
        otherTitleEm:  'Services',
      },

      // ── Les 8 services (titre, sous-titre, accroche, description, fonctionnalités) ──
      items: {
        'developpement-web-mobile': {
          title: 'Développement Web & Mobile',
          shortTitle: 'Web & Mobile',
          tagline: 'Des solutions numériques sur mesure qui propulsent votre croissance',
          description: 'Nexia Digital conçoit et développe des sites web vitrine, e-commerce, et applications mobiles iOS/Android performants, optimisés SEO et adaptés à tous les appareils. Nous utilisons les technologies les plus récentes pour vous offrir une présence digitale inégalée.',
          features: [
            'Sites web vitrine & corporate responsive',
            'Applications e-commerce performantes (WooCommerce, Shopify, custom)',
            'Applications mobiles iOS & Android (React Native, Flutter)',
            'PWA, Progressive Web Apps',
            'Intégration CMS (WordPress, Strapi, Sanity)',
            'Optimisation des performances et Core Web Vitals',
            'API REST & GraphQL',
            'Maintenance & support technique',
          ],
        },
        'design-graphique': {
          title: 'Graphisme & Design',
          shortTitle: 'Graphisme',
          tagline: 'Donnez une identité visuelle forte qui marque les esprits',
          description: "Notre studio de design crée des identités visuelles percutantes, des supports de communication imprimés et digitaux, et des interfaces UI/UX qui convertissent. Chaque pixel est pensé pour refléter l'ADN de votre marque et séduire votre cible.",
          features: [
            "Création d'identité visuelle & logo",
            'Charte graphique complète',
            'Design UI/UX pour web et mobile',
            'Supports print (flyers, brochures, affiches)',
            'Packaging et design produit',
            'Infographies et data visualization',
            'Templates réseaux sociaux',
            'Brand guidelines',
          ],
        },
        'community-management': {
          title: 'Community Management',
          shortTitle: 'Community',
          tagline: 'Fédérez une communauté engagée autour de votre marque',
          description: 'Notre équipe de community managers experts gère votre présence sur Facebook, Instagram, LinkedIn, TikTok et X. Nous créons du contenu stratégique, animons votre communauté et augmentons votre notoriété digitale avec des stratégies data-driven.',
          features: [
            'Stratégie de contenu social media',
            'Création et planification de posts',
            'Gestion de Facebook, Instagram, LinkedIn, TikTok, X',
            'Animation de communauté et modération',
            'Gestion des avis et réputation en ligne',
            'Reporting mensuel et analytics',
            'Veille concurrentielle',
            'Gestion de crise digitale',
          ],
        },
        'audiovisuel-motion-design': {
          title: 'Audiovisuel & Motion Design',
          shortTitle: 'Motion Design',
          tagline: 'Des contenus visuels qui captivent et convertissent',
          description: "Nexia Digital produit des vidéos corporate, spots publicitaires, motion graphics et animations 2D/3D qui donnent vie à votre marque. Du tournage à la post-production, nous gérons l'intégralité de votre production audiovisuelle.",
          features: [
            'Production vidéo corporate et institutionnelle',
            'Spots publicitaires TV et digital',
            'Motion graphics et animations 2D/3D',
            'Tutoriels et vidéos explicatives (explainer videos)',
            'Reels et contenus courts pour réseaux sociaux',
            'Générique, intro & outro pour YouTube',
            'Sous-titrage et post-production',
            'Drone & prises de vue aériennes',
          ],
        },
        'marketing-digital': {
          title: 'Marketing Digital & Publicité',
          shortTitle: 'Marketing Digital',
          tagline: 'Des stratégies marketing qui génèrent un ROI mesurable',
          description: 'Maximisez votre retour sur investissement avec nos stratégies de marketing digital intégrées : SEO, Google Ads, Meta Ads, email marketing et growth hacking. Nous pilotons vos campagnes avec une approche 100% data-driven pour maximiser votre ROI.',
          features: [
            'Référencement naturel SEO (on-page & off-page)',
            'Publicité Google Ads (Search, Display, Shopping)',
            'Campagnes Meta Ads (Facebook & Instagram)',
            'Email marketing et automation',
            'Stratégie de contenu et inbound marketing',
            'Analyse et reporting de performance',
            'Optimisation du taux de conversion (CRO)',
            'Growth hacking et acquisition clients',
          ],
        },
        'strategie-digitale': {
          title: 'Stratégie & Consulting',
          shortTitle: 'Consulting',
          tagline: 'Un regard expert pour accélérer votre transformation digitale',
          description: 'Nos consultants stratégiques vous accompagnent dans la définition et la mise en œuvre de votre transformation digitale. Audit, roadmap, conseil en positionnement, nous vous guidons avec une vision globale et une expertise sectorielle reconnue.',
          features: [
            'Audit digital complet',
            'Stratégie de transformation digitale',
            'Conseil en positionnement et branding',
            'Analyse de la concurrence et benchmarking',
            'Plan de communication intégré',
            "Formation et coaching d'équipe",
            'KPI et tableau de bord stratégique',
            'Accompagnement et suivi post-implémentation',
          ],
        },
        'solutions-ia-sur-mesure': {
          title: 'Solutions IA Sur Mesure',
          shortTitle: 'Intelligence IA',
          tagline: 'Des intelligences artificielles qui travaillent pour vous 24h/24',
          description: "Nexia Digital conçoit et intègre des solutions d'intelligence artificielle sur mesure pour automatiser vos processus, booster votre marketing et offrir des expériences client exceptionnelles. De l'agent conversationnel aux analytics prédictifs, nous mettons l'IA au service de votre croissance.",
          features: [
            'Agent conversationnel IA : assistants virtuels intelligents',
            'Chatbots IA avancés : solutions de messagerie automatisée',
            'Automatisation IA : workflows intelligents et intégrations CRM',
            'Analytics prédictifs : analyses avancées avec Machine Learning',
            'IA Marketing : suite complète de marketing digital IA',
            'Génération automatique de contenus (emails, posts, fiches produits)',
            'Pré-qualification client via formulaires intelligents',
            'Intégration API IA (OpenAI, Claude, Gemini…)',
          ],
        },
        'seo-sea': {
          title: 'SEO & SEA',
          shortTitle: 'SEO & SEA',
          tagline: 'Dominez Google en référencement naturel et payant',
          description: 'Nexia Digital conçoit et pilote des stratégies SEO et SEA performantes pour propulser votre visibilité sur Google. Du référencement naturel à long terme aux campagnes Google Ads à fort ROI, nous combinons les deux leviers pour maximiser votre acquisition de trafic qualifié et générer un flux constant de leads.',
          features: [
            'Audit SEO complet (technique, on-page, off-page)',
            'Optimisation du référencement naturel & contenu',
            'SEO local & Google Business Profile',
            'Netlinking & stratégie de backlinks',
            'Campagnes Google Ads (Search, Display, Shopping, YouTube)',
            'Campagnes Bing Ads & retargeting',
            'Suivi des KPI et reporting mensuel détaillé',
            'A/B testing & optimisation du taux de conversion',
          ],
        },
      },
    },

    portfolio: {
      eyebrow: 'Notre Portfolio',
      titlePre: 'Nos dernières',
      titleEm: 'réalisations',
      desc: 'Une sélection de projets que nous avons menés avec passion pour nos clients.',
      emptyTitle: 'Projets bientôt disponibles',
      emptyDesc: 'Notre équipe travaille à mettre en ligne nos réalisations. Revenez bientôt !',
      visitLabel: 'Visiter le site',

      // Page /portfolio
      seoTitle: 'Portfolio : Projets réalisés par Nexia Digital',
      seoDesc: 'Explorez le portfolio de notre agence digitale, Nexia Digital. Découvrez nos réalisations web, design et campagnes marketing pour nos clients en France.',
      seoKeywords: 'portfolio agence digitale, réalisations web, projets design, applications mobiles',
      pageEyebrow: 'Portfolio',
      pageTitlePre: 'Nos Réalisations',
      pageTitleEm: 'Qui Font la Différence',
      pageDesc: 'Chaque projet est une histoire de collaboration, de créativité et de résultats concrets. Découvrez comment nous aidons nos clients à dominer leur marché digital.',
      cardCta: 'Voir le projet',
      visitSite: 'Visiter le site',

      // PDF Viewer (sur page portfolio + presentation)
      pdfEyebrow: '— Notre portfolio',
      pdfTitle: 'Portfolio Nexia Digital · 2026',
      pdfDownload: 'Télécharger',
      pdfFullscreen: 'Plein écran',
      pdfHint: 'Cliquez sur les coins des pages ou utilisez les boutons ← → pour feuilleter.',
    },

    notfound: {
      seoTitle: 'Page Introuvable — Nexia Digital',
      title: 'Page Introuvable',
      desc: "Oups ! La page que vous cherchez n'existe pas ou a été déplacée. Pas d'inquiétude, revenons ensemble sur la bonne piste.",
      home: "Retour à l'accueil",
      back: 'Page précédente',
      explore: 'Ou explorez :',
      services: 'Nos Services',
      portfolio: 'Portfolio',
      contact: 'Contact',
      devis: 'Demander un Devis',
    },

    roue: {
      seoTitle: 'Roue de la Chance — Nexia Digital · Stand CDM Scrabble Tunis 2026',
      seoDesc: 'Nexia Digital vous attend au stand des 54ᵉˢ Championnats du Monde de Scrabble Francophone à Tunis. Tentez votre chance à notre Roue et gagnez des remises et services offerts.',

      event: {
        location: 'Stand Nexia Digital · Tunis 2026',
        title: 'Retrouvez-nous aux 54ᵉˢ Championnats du Monde de Scrabble Francophone',
        desc: "Nexia Digital est fière d'être partenaire des CDM Scrabble Tunis 2026. Venez à notre stand pour tourner la roue et tenter de gagner des remises exclusives et des services digitaux offerts !",
      },

      eyebrow: 'Jeu concours',
      titlePre: 'Tentez',
      titleEm: 'votre chance',
      subtitle: 'Remplissez ce formulaire pour participer au tirage. Tournez la roue et gagnez une remise ou un service Nexia Digital offert !',

      prizes: {
        site40Line1: 'sur un site web',
        site40Sub: 'Site web premium',
        charte35Line1: 'sur une charte graphique',
        charte35Sub: 'Logo + Identité visuelle',
        site20Line1: 'sur un site web',
        site20Sub: 'Site vitrine professionnel',
        charte15Line1: 'sur une charte graphique',
        cadeauTitle: 'CADEAU SURPRISE',
        cadeauSub: '',
        retryTitle: 'DEUXIÈME CHANCE',
        retrySub: 'Relancez la roue !',
      },

      secondChanceMsg: 'Vous avez la chance de rejouer ! Tournez à nouveau la roue pour découvrir votre lot.',
      retryBtn: 'Relancer la roue',

      firstName: 'Prénom',
      lastName: 'Nom',
      phone: 'Téléphone',
      email: 'Email',
      projet: 'Votre projet',
      notes: 'Notes complémentaires',
      phFirstName: 'Jean',
      phLastName: 'Dupont',
      phPhone: '+33 6 12 34 56 78',
      phEmail: 'jean.dupont@email.fr',
      phProjet: 'Ex : refonte de site, campagne SEO, création de logo…',
      phNotes: 'Dites-nous en un peu plus sur votre projet ou vos attentes',
      submit: 'Valider et tourner la roue',
      submitting: 'Envoi en cours…',
      legal: 'En participant, vous acceptez que vos données soient traitées par Nexia Digital pour vous recontacter au sujet de votre lot.',
      legalLink: 'En savoir plus',

      toastReq: 'Prénom, nom, téléphone et email sont obligatoires.',
      toastEmail: 'Adresse email invalide.',
      toastErr: 'Une erreur est survenue. Réessayez.',

      wheelEyebrow: 'À vous de jouer',
      wheelTitlePre: 'Tournez',
      wheelTitleEm: 'la roue',
      wheelSubtitle: 'Cliquez sur le bouton ci-dessous pour lancer la roue et découvrir votre lot !',
      spinBtn: 'Tourner la roue',
      spinning: 'La roue tourne…',

      resultEyebrow: 'Bravo, vous avez gagné',
      congrats: 'Félicitations',
      won: 'Vous venez de remporter :',
      resultDesc: "Notre équipe vous contactera très prochainement par email pour vous transmettre votre code ou activer votre lot. À très vite !",
      resultCta: 'Discuter de mon projet',
      resultHome: "Retour à l'accueil",
      replay: 'Rejouer',
    },

    presentation: {
      seoTitle: 'Présentation — Nexia Digital · Portfolio 2026',
      seoDesc: 'Découvrez Nexia Digital : agence digitale, branding, développement web, social media et plus. Téléchargez notre portfolio 2026 (présentation PDF).',
      ogTitle: 'Présentation Nexia Digital — Portfolio 2026',
      ogDesc: 'Notre savoir-faire en branding, web, design et marketing — toutes nos réalisations dans un seul document.',

      eyebrow: 'Portfolio 2026',
      titlePre: 'Découvrez',
      titleEm: 'Nexia Digital',
      subtitle: 'Une agence digitale complète qui accompagne les entreprises dans leur transformation. Notre portfolio rassemble nos plus belles réalisations en branding, développement web, solutions IA, SEO, social media et supports print.',
      download: 'Télécharger le PDF',
      openFullscreen: 'Ouvrir en plein écran',
      discuss: 'Discutons de votre projet',

      ctaEyebrow: '— Convaincu ?',
      ctaTitlePre: 'Et si on parlait',
      ctaTitleEm: 'de votre projet',
      ctaTitlePost: '?',
      ctaDesc: 'Vous avez vu ce que nous faisons. À votre tour de nous raconter vos ambitions. Nous répondons sous 24 h.',
      ctaQuote: 'Demander un devis',
      ctaWrite: 'Nous écrire',
    },

    contactPage: {
      seoTitle: 'Contactez notre Agence de communication digitale à Paris',
      seoDesc: "Besoin d'un partenaire pour votre projet web ? Contactez Nexia Digital, agence de communication digitale à Paris. Devis gratuit et réponse sous 24h !",

      heroEyebrow: 'Contactez-Nous',
      heroTitlePre: 'Parlons de',
      heroTitleEm: 'Votre Projet',
      heroDesc: 'Une idée ? Un projet ? Une question ? Notre équipe est là pour vous accompagner. Contactez-nous et recevez une réponse dans les 24h.',

      coordsTitle: 'Nos Coordonnées',
      coordsIntro: "Nous sommes à votre disposition du lundi au vendredi. N'hésitez pas à nous contacter via le formulaire, par téléphone ou email.",
      infoAddressLabel: 'Adresse',
      infoAddressSub: '93260 Les Lilas',
      infoPhoneLabel: 'Téléphone',
      infoPhoneSub: 'Disponible 9h–18h',
      infoEmailLabel: 'Email',
      infoEmailSub: 'Réponse en moins de 24h',
      infoScheduleLabel: 'Horaires',
      infoScheduleValue: 'Lun – Ven : 9h – 18h',
      infoScheduleSub: 'Sam : 9h – 13h',

      quickTitle: 'Accès Rapide',
      quickCta: 'Demander un Devis Gratuit',

      formTitle: 'Envoyez-Nous un Message',
      formNameLabel: 'Nom complet *',
      formNamePh: 'Ex : Jean Dupont',
      formEmailLabel: 'Email *',
      formEmailPh: 'votre@email.com',
      formPhoneLabel: 'Téléphone',
      formPhonePh: '+33 X XX XX XX XX',
      formSubjectLabel: 'Sujet',
      formSubjectPh: '— Choisir un sujet —',
      formMessageLabel: 'Message *',
      formMessagePh: 'Décrivez votre projet ou votre demande...',
      formSubmit: 'Envoyer le message',
      formSubmitting: 'Envoi en cours...',

      toastReq: 'Veuillez remplir tous les champs obligatoires.',
      toastSuccess: 'Message envoyé ! Nous vous répondrons sous 24h.',
      toastError: "Erreur lors de l'envoi. Réessayez.",

      subjects: [
        'Développement Web & Mobile',
        'Graphisme & Design',
        'Community Management',
        'Audiovisuel & Motion Design',
        'Marketing Digital & Publicité',
        'Stratégie & Consulting',
        'Solutions IA Sur Mesure',
        'SEO & SEA',
        'Demande de devis',
        'Autre',
      ],
    },

    legal: {
      seoTitle: 'Mentions Légales & Politique de Confidentialité — Nexia Digital',
      seoDesc: "Mentions légales, politique de confidentialité et informations sur l'utilisation des cookies du site Nexia Digital.",

      heroEyebrow: 'Informations Légales',
      heroTitlePre: 'Mentions Légales &',
      heroTitleEm: 'Confidentialité',
      lastUpdate: 'Dernière mise à jour :',
      toc: 'Sommaire',
      contactBoxTitle: 'Une question sur vos données ?',
      contactBoxText: 'Contactez notre responsable protection des données à',

      sections: [
        {
          title: '1. Éditeur du site',
          content: `Le site web nexia-digital.com est édité par la société Nexia Digital, agence de communication et de marketing digital.

Siège social : 145 Rue de Noisy-le-Sec, 93260 Les Lilas
Email : contact@nexia-digital.com
Téléphone : +33 7 75 21 51 57
Directeur de la publication : Direction Nexia Digital`,
        },
        {
          title: '2. Hébergement',
          content: `Le site est hébergé par Firebase / Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.`,
        },
        {
          title: '3. Propriété intellectuelle',
          content: `L'ensemble des contenus présents sur le site nexia-digital.com (textes, images, graphismes, logo, icônes, sons, logiciels) sont la propriété exclusive de Nexia Digital et sont protégés par les lois internationales relatives à la propriété intellectuelle.

Toute reproduction, représentation, modification, publication, transmission, ou dénaturation, totale ou partielle du site ou de son contenu, par quelque procédé que ce soit, et sur quelque support que ce soit est interdite sans l'autorisation expresse et préalable de Nexia Digital.`,
        },
        {
          title: '4. Données personnelles',
          content: `Nexia Digital collecte des données personnelles via ses formulaires de contact et de demande de devis. Ces données sont utilisées uniquement pour répondre à vos demandes et améliorer nos services.

Conformément à la réglementation en vigueur sur la protection des données personnelles (RGPD), vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles.

Pour exercer ces droits, contactez-nous à : contact@nexia-digital.net

Vos données ne sont jamais cédées, vendues ou louées à des tiers à des fins commerciales.`,
        },
        {
          title: '5. Cookies',
          content: `Le site nexia-digital.com utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic. Les cookies sont de petits fichiers texte stockés sur votre ordinateur.

Types de cookies utilisés :
• Cookies essentiels : nécessaires au fonctionnement du site
• Cookies analytiques : mesure d'audience via Firebase Analytics (anonymisé)
• Cookies de préférences : mémorisation de vos choix

Vous pouvez configurer votre navigateur pour refuser les cookies, ou utiliser notre bannière de consentement pour personnaliser vos préférences.`,
        },
        {
          title: '6. Responsabilité',
          content: `Nexia Digital s'efforce de fournir sur le site nexia-digital.com des informations aussi précises que possible. Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires.

Nexia Digital ne peut être tenue responsable des dommages directs ou indirects résultant de l'accès au site ou de l'utilisation d'informations qui y sont présentées.`,
        },
        {
          title: '7. Liens hypertextes',
          content: `Le site peut contenir des liens vers d'autres sites web. Nexia Digital n'est pas responsable du contenu de ces sites tiers et ne peut être tenu responsable des dommages ou préjudices découlant de leur utilisation.`,
        },
        {
          title: '8. Droit applicable',
          content: `Les présentes mentions légales sont régies par le droit applicable dans le pays de l'éditeur. En cas de litige, les juridictions compétentes seront celles du siège social de Nexia Digital.

Toute question relative aux présentes mentions légales peut être adressée à : contact@nexia-digital.net`,
        },
      ],
    },

    projectDetail: {
      seoFallback: 'Découvrez le projet {title} réalisé par Nexia Digital.',
      breadcrumb: 'Portfolio',
      visitSite: 'Voir le site',
      descriptionTitle: 'Description du Projet',
      galleryTitle: 'Galerie du Projet',
      visualAlt: 'visuel',
      challengesTitle: 'Défis & Solutions',
      infoTitle: 'Informations Projet',
      infoClient: 'Client',
      infoCategory: 'Catégorie',
      infoDuration: 'Durée',
      infoYear: 'Année',
      infoTech: 'Technologies',
      ctaTitle: 'Un projet similaire ?',
      ctaDesc: 'Parlons de votre projet et construisons ensemble votre succès digital.',
      ctaBtn: 'Demander un Devis',
      previewAlt: 'Aperçu',
    },

    connect: {
      seoTitle: 'Connectons-nous — Nexia Digital',
      seoDesc: 'Découvrez Nexia Digital, suivez-nous sur LinkedIn et inscrivez-vous pour devenir partenaire ou client.',

      heroEyebrow: 'Connectons-nous',
      heroTitlePre: 'Bienvenue chez',
      heroTitleEm: 'Nexia Digital',
      heroSubtitleHtml: "Une agence digitale complète — <strong>web, branding, marketing, IA</strong> et plus encore. Nous accompagnons les entreprises dans leur transformation digitale avec stratégie, créativité et engagement. Que vous soyez un futur client ou un futur partenaire apporteur d'affaires, cette page est faite pour vous.",
      ctaLeads: 'Laissez-nous vos coordonnées',
      ctaLinkedin: 'Suivez-nous sur LinkedIn',

      linkedinEyebrow: '— Restons en contact',
      linkedinTitlePre: 'Suivez-nous sur',
      linkedinTitleEm: 'LinkedIn',
      linkedinDesc: 'Actualités, projets en cours, conseils stratégie digitale et opportunités de partenariat — tout passe par notre LinkedIn. Connectez-vous pour ne rien manquer.',
      linkedinCta: 'Rejoindre notre réseau',

      docsEyebrow: "— Pour les apporteurs d'affaires",
      docsTitlePre: 'Documents',
      docsTitleEm: 'à télécharger',
      docsDesc: 'Vous souhaitez nous recommander à votre réseau et toucher des commissions ? Consultez notre kit complet et notre contrat de partenariat.',
      doc1Title: "Kit Apporteur d'affaires",
      doc1Desc: "Tout ce qu'il faut savoir pour nous recommander et toucher vos commissions.",
      doc2Title: 'Contrat de partenariat',
      doc2Desc: "Le contrat d'apporteur d'affaires détaillé, prêt à signer.",
      docDownload: 'Télécharger',
      docSoon: 'Bientôt disponible',

      formEyebrow: '— Restons connectés',
      formTitlePre: 'Laissez-nous vos',
      formTitleEm: 'coordonnées',
      formDescHtml: "Que vous soyez intéressé(e) par nos services ou par notre programme apporteur d'affaires, remplissez ce formulaire — nous vous recontactons sous <strong>24 h</strong>.",
      perk1: 'Réponse rapide sous 24 h',
      perk2: 'Sans engagement',
      perk3: 'Vos données restent confidentielles',

      successTitle: 'Merci !',
      successText: 'Votre demande a bien été enregistrée.\nNous reviendrons vers vous très vite.',
      sendAnother: 'Envoyer une autre demande',

      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      notes: 'Note',
      optional: '(facultatif)',
      phFirstName: 'Jean',
      phLastName: 'Dupont',
      phEmail: 'jean.dupont@email.fr',
      phPhone: '+33 6 12 34 56 78',
      phNotes: 'Dites-nous en quelques mots votre projet, votre intérêt, ou comment vous nous avez connus…',
      submit: 'Envoyer ma demande',
      submitting: 'Envoi en cours…',
      legalHtml: 'En soumettant ce formulaire, vous acceptez que vos données soient traitées par Nexia Digital à des fins de contact uniquement.',
      legalLink: 'En savoir plus',

      toastReq: 'Prénom, nom et email sont obligatoires.',
      toastEmail: 'Email invalide.',
      toastErr: 'Une erreur est survenue. Réessayez ou écrivez-nous directement.',
      toastSuccess: 'Merci ! Nous reviendrons vers vous très vite. 🎉',

      pdfEyebrow: 'Notre Portfolio · 2026',
      pdfTitlePre: 'Découvrez notre',
      pdfTitleEm: 'présentation complète',
      pdfDesc: 'Un document complet qui rassemble qui nous sommes, notre expertise et nos plus belles réalisations en branding, développement web, supports print et social media. Consultez-le en ligne ou téléchargez-le pour le partager.',
      pdfCta1: 'Consulter la présentation',
      pdfCta2: 'Télécharger le PDF',
      pdfBadge: 'Portfolio PDF',
    },

    devis: {
      seoTitle: 'Devis Agence Digitale Paris - Tarifs Web sous 24h | Nexia',
      seoDesc: 'Obtenez votre devis gratuit et sans engagement auprès de Nexia Digital. Agence digitale spécialisée en développement web, SEO, design et marketing.',

      heroEyebrow: 'Devis Gratuit',
      heroTitlePre: 'Démarrons Votre',
      heroTitleEm: 'Projet Ensemble',
      heroDesc: 'Remplissez ce formulaire et recevez un devis personnalisé et gratuit en moins de 24h.',

      step1Label: 'Services',
      step2Label: 'Détails',
      step3Label: 'Informations',

      step1Title: 'Quels services vous intéressent ?',
      step1Sub: 'Sélectionnez un ou plusieurs services (plusieurs choix possibles)',
      step2Title: 'Détails par service',
      step2Sub: 'Donnez-nous plus de contexte sur vos besoins',
      step3Title: 'Vos informations de contact',
      step3Sub: 'Pour vous envoyer votre devis personnalisé',

      continue: 'Continuer',
      back: '← Retour',
      submitting: 'Envoi...',
      submit: 'Envoyer ma Demande',
      selectAtLeast: 'Sélectionnez au moins un service.',
      requiredNameEmail: 'Nom et email requis.',
      submitSuccess: 'Demande envoyée ! Nous vous contacterons sous 24h.',
      submitError: "Erreur lors de l'envoi.",

      selectPh: '— Sélectionner —',
      budgetLabel: 'Budget estimé',
      timelineLabel: 'Délai souhaité',
      descriptionLabel: 'Description du projet',
      descriptionPh: 'Décrivez votre projet, vos objectifs, votre cible et tout ce qui peut nous aider à mieux comprendre votre besoin...',

      nameLabel: 'Nom complet *',
      namePh: 'Votre nom et prénom',
      emailLabel: 'Email professionnel *',
      emailPh: 'votre@email.com',
      phoneLabel: 'Téléphone',
      phonePh: '+33 X XX XX XX XX',
      companyLabel: 'Entreprise / Marque',
      companyPh: 'Nom de votre entreprise',

      summaryTitle: 'Résumé de votre demande',
      summaryBudget: 'Budget :',
      summaryTimeline: 'Délai :',

      successTitle: 'Demande Envoyée !',
      successTextHtml: 'Merci <strong>{name}</strong> ! Nous avons bien reçu votre demande de devis. Notre équipe vous contactera sous <strong>24 heures ouvrables</strong>.',
      successHome: "Retour à l'accueil",
      successPortfolio: 'Voir notre Portfolio',

      budgets: ['< 1 000 €', '1 000 – 5 000 €', '5 000 – 15 000 €', '15 000 – 30 000 €', '30 000+ €', 'À définir ensemble'],
      timelines: ['Urgent (< 1 mois)', '1 à 3 mois', '3 à 6 mois', '6 mois+', 'Flexible'],

      services: {
        web: {
          label: 'Développement Web & Mobile',
          fields: {
            webType: { label: 'Type de projet', options: ['Site vitrine', 'Site e-commerce', 'Application web', 'Application mobile', 'PWA'] },
            webTech: { label: 'Technologies préférées', placeholder: 'React, WordPress, Flutter...' },
            webPages: { label: 'Nombre de pages approximatif', placeholder: 'Ex: 10' },
          },
        },
        design: {
          label: 'Graphisme & Design',
          fields: {
            designType: { label: 'Type de design', options: ['Logo & identité visuelle', 'Charte graphique', 'UI/UX design', 'Supports print', 'Packaging', 'Infographies'] },
            designFiles: { label: 'Fichiers sources souhaités', placeholder: 'AI, PSD, Figma...' },
          },
        },
        social: {
          label: 'Community Management',
          fields: {
            socialPlatforms: { label: 'Réseaux sociaux', placeholder: 'Facebook, Instagram, LinkedIn...' },
            socialFrequency: { label: 'Fréquence de publication souhaitée', options: ['3 posts/semaine', '5 posts/semaine', '7 posts/semaine', 'À définir'] },
            socialBudget: { label: 'Budget publicité mensuel (€)', placeholder: 'Ex: 500' },
          },
        },
        video: {
          label: 'Audiovisuel & Motion Design',
          fields: {
            videoType: { label: 'Type de contenu', options: ['Vidéo corporate', 'Spot publicitaire', 'Motion graphics', 'Explainer video', 'Reels & shorts', 'Drone'] },
            videoDuration: { label: 'Durée approximative', placeholder: 'Ex: 1-2 minutes' },
          },
        },
        marketing: {
          label: 'Marketing Digital & Publicité',
          fields: {
            mktChannels: { label: 'Canaux marketing', placeholder: 'SEO, Google Ads, Meta Ads, Email...' },
            mktBudget: { label: 'Budget publicitaire mensuel (€)', placeholder: 'Ex: 1000' },
            mktGoal: { label: 'Objectif principal', options: ['Notoriété', 'Génération de leads', 'Ventes en ligne', 'Trafic site', 'Fidélisation'] },
          },
        },
        consulting: {
          label: 'Stratégie & Consulting',
          fields: {
            consultingNeed: { label: 'Besoin principal', options: ['Audit digital', 'Stratégie de marque', 'Plan de communication', 'Formation', 'Transformation digitale'] },
          },
        },
        ia: {
          label: 'Solutions IA Sur Mesure',
          fields: {
            iaType: { label: 'Type de solution IA', options: ['Agent conversationnelle IA', 'Chatbot IA avancé', 'Automatisation IA & CRM', 'Analytics prédictifs (ML)', 'IA Marketing', 'Autre / combinaison'] },
            iaIntegration: { label: 'Intégrations souhaitées', placeholder: 'CRM, site web, WhatsApp, Slack...' },
            iaObjectif: { label: 'Objectif principal', options: ['Automatiser le support client', 'Générer des leads qualifiés', 'Automatiser des tâches internes', 'Analyser les données / prédictions', 'Créer du contenu automatiquement', 'Autre'] },
          },
        },
        'seo-sea': {
          label: 'SEO & SEA',
          fields: {
            seoSeaType: { label: 'Type de prestation', options: ['SEO uniquement', 'SEA uniquement', 'SEO + SEA combinés', 'Audit SEO', 'SEO local (Google Business)'] },
            seoSeaMotsCles: { label: 'Mots-clés ciblés', placeholder: 'Ex: agence déménagement Paris, scrabble francophone...' },
            seoSeaBudget: { label: 'Budget publicitaire mensuel (€)', placeholder: 'Ex: 500' },
            seoSeaObjectif: { label: 'Objectif principal', options: ['Générer des leads', 'Augmenter le trafic', 'Visibilité locale', 'Ventes en ligne', 'Notoriété de marque'] },
          },
        },
      },
    },

    apporteursPage: {
      seoTitle: "Devenir Apporteur d'Affaires | Programme Partenaires Nexia Digital",
      seoDesc: "Rejoignez le programme Apporteurs d'affaires de Nexia Digital : 12% de commission de base, 15% dès le 4e client apporté dans l'année. Paiement sous 30 jours.",
      seoKeywords: "apporteur d'affaires, partenariat, commission, programme partenaire, agence digitale, Nexia Digital, business developer, freelance",
      ogTitle: "Devenir Apporteur d'Affaires | Nexia Digital",
      ogDesc: "Programme Apporteurs d'affaires Nexia Digital : 12% de commission, 15% dès le 4e client, paiement sous 30 jours, suivi sur 12 mois.",

      heroEyebrow: 'Programme Partenaires',
      heroTitleLine1: 'Recommandez nos services.',
      heroTitleEm: "Jusqu'à 15%",
      heroTitleAfter: 'de commission sur chaque client signé.',
      heroDescHtml: "Nexia Digital recrute des apporteurs d'affaires indépendants. Vous nous présentez une entreprise qui a besoin d'un site, de développement sur-mesure, de SEO, de design, d'une solution IA ou d'une stratégie digitale — nous nous occupons du reste. Vous touchez <strong>12% de commission</strong> sur chaque mission concrétisée, et <strong>15% dès le 4e client apporté dans l'année</strong>.",
      heroCtaPrimary: "Devenir apporteur d'affaires",
      heroCtaSecondary: 'Comment ça marche',

      stats: [
        { num: '12→15', suffix: '%', label: "commission évolutive sur le CA HT encaissé — 12% de base, 15% dès le 4e client" },
        { num: '30', suffix: ' jours', label: 'délai maximum de versement de votre commission après encaissement client' },
        { num: '12', suffix: ' mois', label: 'de commissionnement sur tous les contrats signés avec votre client apporté' },
      ],

      stepsEyebrow: 'Comment ça marche',
      stepsTitlePre: 'Un partenariat',
      stepsTitleEm: 'simple',
      stepsTitlePost: ', transparent, et structuré.',
      stepsLede: "Pas de quota, pas d'obligation de résultat, pas d'engagement de temps. Vous présentez quand vous avez l'occasion, nous nous chargeons du commercial et de la prestation.",
      stepWord: 'Étape',
      steps: [
        { n: '01', title: 'Vous candidatez', desc: 'Vous remplissez le formulaire ci-dessous. Nous étudions votre profil sous 5 jours ouvrés.' },
        { n: '02', title: 'Nous signons le contrat', desc: "Un contrat d'apport d'affaires clair et équitable, sans exclusivité, est mis en place entre nous." },
        { n: '03', title: 'Vous nous présentez', desc: "Dès qu'une opportunité se présente dans votre réseau, vous nous transmettez le contact qualifié." },
        { n: '04', title: 'Vous percevez', desc: "Dès la facturation et l'encaissement de la mission, vous recevez votre commission sous 30 jours." },
      ],

      commissionEyebrow: 'La rémunération',
      commissionTitlePre: 'Une commission',
      commissionTitleEm: 'évolutive',
      commissionTitlePost: ', payée vite, sans surprise.',
      commissionTierDefaultLabel: 'Par défaut',
      commissionTierDefaultDesc: 'sur toute affaire signée',
      commissionArrowLabel: 'Fidélisation',
      commissionTierBonusLabel: 'Dès le 4e client',
      commissionTierBonusDesc: "apporté dans l'année",
      commissionCaptionHtml: "Commission calculée sur le chiffre d'affaires HT facturé et encaissé, <strong>sans plafond</strong>.",
      commissionPoints: [
        { title: 'Tarif de base : 12%', desc: "Vous touchez 12% du CA HT encaissé sur chaque affaire signée — sans plafond, qu'elle soit à 1 000 € ou à 50 000 €." },
        { title: 'Bonus fidélité : 15%', desc: "À partir du 4e client apporté dans l'année, votre taux passe automatiquement à 15% — un avantage qui récompense votre régularité." },
        { title: 'Paiement sous 30 jours', desc: "Dès que Nexia Digital a encaissé la facture client, votre commission est virée dans les 30 jours, avec un suivi transparent." },
        { title: 'Suivi sur 12 mois', desc: 'Les avenants, renouvellements et prestations complémentaires de votre client sont commissionnés pendant 12 mois.' },
      ],

      servicesEyebrow: 'Ce que vous pouvez recommander — Pôle digital classique',
      servicesTitlePre: 'Nos prestations',
      servicesTitleEm: 'digitales',
      servicesTitlePost: '.',
      servicesLedeHtml: "Tout besoin lié au web ou à la visibilité en ligne est éligible. Si vous avez un doute, présentez-nous : nous qualifions ensemble. <strong>→ Nouveau : nous proposons aussi de l'automatisation IA et des agents conversationnels (voir ci-dessous).</strong>",
      servicesClassic: [
        { tag: 'Création', title: 'Sites internet', desc: 'Sites vitrines, sites e-commerce, refontes complètes, landing pages performantes.' },
        { tag: 'Visibilité', title: 'Référencement SEO', desc: 'Audit, stratégie de contenu, optimisation technique, netlinking et suivi de positions.' },
        { tag: 'Acquisition', title: 'Marketing digital', desc: 'Google Ads, Meta Ads, campagnes de génération de leads, stratégies social media.' },
        { tag: 'Conseil', title: 'Stratégie digitale', desc: "Audit, accompagnement et plans d'action sur mesure pour PME et professionnels." },
        { tag: 'Identité', title: 'Graphisme & branding', desc: 'Logo, identité visuelle, charte graphique, supports de communication imprimés et digitaux.' },
        { tag: 'Maintenance', title: 'Suivi & infogérance', desc: 'Hébergement, maintenance technique, sauvegardes, mises à jour de sécurité.' },
      ],

      aiBadge: '★ Nouvelle activité',
      aiTitleLine1Pre: 'Automatisation &',
      aiTitleLine1Em: 'Agents IA',
      aiTitleLine1Post: '.',
      aiTitleLine2: 'Une nouvelle ligne à fort potentiel.',
      aiLedeHtml: "Nexia Digital étend son offre à l'<strong>automatisation no-code (n8n)</strong> et aux <strong>agents conversationnels IA</strong>. Un marché en plein essor, des budgets clients de <strong class=\"text-accent2\">800 € à 20 000 €</strong> par mission, et <strong>la même grille de commission</strong> pour vous (12%, puis 15% dès le 4e client). Voici les 4 familles de prestations que vous pouvez recommander.",
      aiCardsCiblesLabel: 'Cibles',
      aiCardsBudgetLabel: 'Budget client',
      aiCards: [
        {
          letter: 'Catégorie A',
          title: 'Agents IA conversationnels',
          items: [
            'Chatbot support client multicanal (WhatsApp + site web)',
            'Assistant IA interne sur base documentaire (RAG)',
            'Voicebot pour qualification de leads (Vapi, Retell)',
            'Agent autonome multi-outils (recherche, scraping, synthèse)',
          ],
          cibles: 'PME e-commerce, scale-ups, agences immobilières, cabinets médicaux',
          budget: '2 500 € – 20 000 €',
        },
        {
          letter: 'Catégorie B',
          title: 'Automatisation marketing & sales',
          items: [
            'Lead scoring & enrichissement CRM automatisé',
            'Cold outreach IA personnalisé (email + LinkedIn)',
            'Pipeline de génération de contenu (blog, social)',
            'Scraping LinkedIn + analyse IA + alerting',
          ],
          cibles: 'SaaS B2B, agences growth, cabinets de recrutement',
          budget: '1 200 € – 7 000 €',
        },
        {
          letter: 'Catégorie C',
          title: 'Workflows internes entreprise',
          items: [
            'Onboarding RH automatisé (signature, comptes, accès)',
            'Reporting automatique multi-sources sans Power BI',
            'Triage de tickets support avec IA',
            'Synchronisation SaaS (Notion ↔ Airtable ↔ HubSpot)',
          ],
          cibles: 'Scale-ups tech, PME tertiaires, agences digitales',
          budget: '800 € – 9 000 €',
        },
        {
          letter: 'Catégorie D',
          title: 'Intégrations data & API',
          items: [
            'Connexion ERP legacy vers stack moderne',
            'Pipelines OCR + IA pour factures et documents',
            'Middleware webhooks sur mesure entre applications',
            'Connecteurs API personnalisés',
          ],
          cibles: 'PME industrielles, cabinets comptables, SaaS',
          budget: '1 000 € – 15 000 €',
        },
      ],
      aiNoteHtml: "<strong>À retenir :</strong> tout dirigeant qui dit « on perd trop de temps en tâches manuelles », « le support client coûte cher », « on veut un assistant IA interne », « notre CRM n'est pas exploité » ou « on a besoin de connecter nos outils » est un prospect qualifié. Présentez-le, nous nous chargeons de la qualification technique.",

      profileEyebrow: 'Profil recherché',
      profileTitlePre: 'Qui peut devenir',
      profileTitleEm: 'apporteur',
      profileTitlePost: ' ?',
      profileDesc: 'Notre programme est ouvert à toute personne en capacité de recommander professionnellement nos services, sans restriction de statut.',
      profileItems: [
        "Indépendants et freelances en lien avec des dirigeants d'entreprise",
        'Consultants, coachs, experts-comptables, avocats, agences de communication',
        'Commerciaux et professionnels du networking B2B',
        "Cadres et chefs d'entreprise avec un réseau professionnel actif",
        'Toute personne pouvant facturer une commission (auto-entrepreneur minimum)',
      ],

      formInfoTitle: 'Rejoignez le programme',
      formInfoLead: 'Remplissez ce formulaire — nous revenons vers vous sous 5 jours ouvrés avec une proposition de contrat et un point de cadrage.',
      formInfoPoints: [
        'Commission 12% de base, 15% dès le 4e client/an',
        "Aucun frais d'inscription, aucun engagement",
        'Paiement sous 30 jours après encaissement',
        'Suivi de vos apports sur 12 mois',
        'Référent dédié pour qualifier vos prospects',
      ],
      formContactTitle: 'Une question ?',

      successTitle: 'Merci pour votre candidature !',
      successDesc: 'Votre demande a bien été enregistrée. Notre équipe partenariats vous contactera sous 5 jours ouvrés pour finaliser votre activation et vous transmettre une proposition de contrat.',
      successCta: 'Inscrire un autre profil',

      formTitle: 'Formulaire de candidature',
      formSub: "Remplissez ce formulaire en 2 minutes. Tous les champs marqués d'un * sont obligatoires.",
      formLabelName: 'Nom complet *',
      formPhName: 'Ex : Jean Dupont',
      formLabelEmail: 'Email *',
      formPhEmail: 'votre@email.com',
      formLabelPhone: 'Téléphone *',
      formPhPhone: '+33 X XX XX XX XX',
      formLabelCity: 'Ville',
      formPhCity: 'Paris, Lyon, Tunis…',
      formLabelProfile: 'Profil *',
      formProfilePlaceholder: '— Choisir un profil —',
      formLabelCompany: 'Entreprise / Organisation',
      formPhCompany: 'Optionnel',
      formLabelNetwork: 'Taille de votre réseau professionnel',
      formNetworkPlaceholder: '— Sélectionner —',
      formLabelServices: 'Services qui vous intéressent',
      formLabelMotivation: 'Votre parcours en quelques lignes',
      formPhMotivation: 'Activité principale, type de prospects que vous pouvez nous présenter, motivation…',
      formAcceptTerms: "J'accepte les conditions du programme apporteurs d'affaires et autorise Nexia Digital à me contacter au sujet de mon inscription.",
      formSubmit: 'Envoyer ma candidature',
      formSubmitting: 'Envoi en cours...',
      profiles: [
        'Indépendant / Freelance',
        'Consultant / Coach',
        "Dirigeant d'entreprise",
        'Commercial / Business Developer',
        'Agence partenaire',
        'Étudiant / Stagiaire',
        'Autre',
      ],
      networkSizes: [
        '1 – 10 contacts',
        '10 – 50 contacts',
        '50 – 200 contacts',
        '200 – 1000 contacts',
        'Plus de 1000 contacts',
      ],
      servicesInterest: [
        'Développement Web & Mobile',
        'Graphisme & Design',
        'Community Management',
        'Audiovisuel & Motion Design',
        'Marketing Digital & Publicité',
        'Stratégie & Consulting',
        'Solutions IA Sur Mesure',
        'SEO & SEA',
      ],
      toastRequired: 'Veuillez remplir tous les champs obligatoires.',
      toastTerms: 'Vous devez accepter les conditions du programme.',
      toastSuccess: 'Inscription envoyée ! Notre équipe vous contactera sous 48h.',
      toastError: "Erreur lors de l'envoi. Réessayez.",

      faqEyebrow: 'Vos questions',
      faqTitlePre: "Tout ce qu'il faut",
      faqTitleEm: 'savoir',
      faqTitlePost: '.',
      faqIntro: "Une question qui ne figure pas ici ? Notre équipe partenariats vous répond directement.",
      faq: [
        {
          q: "Suis-je obligé d'avoir une entreprise pour devenir apporteur ?",
          a: "Oui. Pour percevoir une commission légale, vous devez pouvoir nous facturer. Le statut le plus simple est la micro-entreprise (auto-entrepreneur), mais SARL, SAS, EI ou portage salarial conviennent également.",
        },
        {
          q: 'Y a-t-il un nombre minimum de prospects à apporter ?',
          a: "Non. Aucune obligation de volume, aucun quota, aucun engagement de temps. Vous nous présentez quand l'occasion se présente naturellement dans votre réseau.",
        },
        {
          q: "Comment savez-vous qu'un prospect vient bien de moi ?",
          a: "Chaque prospect est tracé dès sa transmission par e-mail ou via le formulaire dédié que nous mettons à votre disposition. L'antériorité de l'apport vous est garantie contractuellement pendant toute la durée du contrat.",
        },
        {
          q: 'Quand exactement ma commission est-elle versée ?',
          a: 'La commission est due après encaissement effectif de la facture par Nexia Digital. Vous nous adressez ensuite une facture de commission, et le virement intervient dans un délai maximum de 30 jours.',
        },
        {
          q: 'Comment fonctionne le passage de 12% à 15% au 4e client ?',
          a: "Votre commission est de 12% sur les 3 premiers clients que vous nous apportez dans l'année civile. À partir du 4e client signé dans la même année, votre taux passe automatiquement à 15% sur cette mission et toutes les suivantes jusqu'à la fin de l'année. Le compteur est remis à zéro chaque 1er janvier. Important : seuls les clients ayant abouti à une signature et un encaissement entrent dans le décompte.",
        },
        {
          q: 'Le contrat est-il exclusif ?',
          a: "Non. Vous restez libre d'exercer toute autre activité professionnelle ou de collaborer avec d'autres prestataires, hors agences digitales directement concurrentes pour les prospects que vous nous avez identifiés.",
        },
        {
          q: "Les prestations d'automatisation IA sont-elles commissionnées de la même façon ?",
          a: "Oui, à 100%. Les missions de notre nouvelle ligne (automatisation n8n, agents IA, chatbots, voicebots, intégrations) sont commissionnées exactement aux mêmes conditions que nos services digitaux classiques : 12% du chiffre d'affaires HT encaissé (15% dès le 4e client apporté dans l'année), paiement sous 30 jours, suivi sur 12 mois. Les budgets clients y sont souvent plus élevés (jusqu'à 20 000 € par projet).",
        },
        {
          q: 'Que se passe-t-il si je résilie le contrat ?',
          a: "Vous pouvez résilier à tout moment avec un préavis de 15 jours. Les commissions sur les clients déjà apportés restent dues pour toutes les prestations facturées dans les 12 mois suivant la première facture.",
        },
      ],
    },

    questionnaire: {
      seoTitle: 'Questionnaire Client — Nexia Digital',
      seoDesc: 'Remplissez notre questionnaire client pour nous permettre de comprendre précisément votre projet et vous adresser une proposition personnalisée.',

      heroEyebrow: 'Questionnaire Client',
      heroTitleLine1: 'Parlez-nous de',
      heroTitleEm: 'Votre Projet',
      heroDesc: 'Renseignez uniquement les parties qui vous concernent. Ce document nous permet de vous adresser une proposition personnalisée dans les plus brefs délais.',

      stepsNav: [
        { label: 'Identité' },
        { label: 'Objectifs' },
        { label: 'Site & Contenu' },
        { label: 'Branding & SEO' },
        { label: 'IA & Réseaux' },
        { label: 'Budget' },
      ],

      next: 'Suivant',
      back: '← Retour',
      submit: 'Envoyer le Questionnaire',
      submitting: 'Envoi en cours...',

      toastStep1: 'Veuillez renseigner au minimum votre nom et votre email.',
      toastRequired: 'Nom et email requis.',
      toastSuccess: 'Questionnaire envoyé ! Nous vous contacterons rapidement.',
      toastError: "Erreur lors de l'envoi. Veuillez réessayer.",

      successTitle: 'Questionnaire Envoyé !',
      successDescHtml: 'Merci <strong>{name}</strong> ! Nous avons bien reçu votre questionnaire. Notre équipe va analyser vos besoins et vous contactera très prochainement avec une proposition personnalisée.',
      successHome: "Retour à l'accueil",
      successContact: 'Nous contacter',

      // Step 1
      s1Title: '1. Informations Générales',
      s1NomClientLabel: "Nom du client / entreprise *",
      s1NomClientPh: "Votre nom ou nom de l'entreprise",
      s1InterlocuteurLabel: 'Interlocuteur principal',
      s1InterlocuteurPh: 'Prénom et nom',
      s1EmailLabel: 'Email *',
      s1EmailPh: 'votre@email.com',
      s1TelephoneLabel: 'Téléphone',
      s1TelephonePh: '+33 6 XX XX XX XX',

      s2Title: "2. Identité de l'Entreprise",
      s2NomLegalLabel: 'Nom légal (KBIS)',
      s2NomLegalPh: "Nom légal de l'entreprise",
      s2SecteurLabel: "Secteur d'activité",
      s2SecteurPh: 'Ex: Restauration, Immobilier...',
      s2DateLabel: 'Date de création',
      s2DatePh: 'Ex: 2018',
      s2SloganLabel: 'Slogan / accroche principale',
      s2SloganPh: 'Votre accroche',
      s2ValeursLabel: 'Vos valeurs',
      s2AutreValeurPh: 'Autre valeur...',
      s2AnneesLabel: "Années d'expérience",
      s2AnneesPh: 'Ex: 10 ans',
      s2NombreClientsLabel: 'Nombre de clients',
      s2NombreClientsPh: 'Ex: +500 clients',
      s2RealisationsLabel: 'Réalisations / projets marquants',
      s2RealisationsPh: 'Décrivez vos principales réalisations',
      s2VisuelsLabel: 'Visuels disponibles',

      // Step 2
      s3Title: '3. Objectifs du Projet',
      s3TypeProjetLabel: 'Type de projet',
      s3AutreTypeProjetPh: 'Autre type de projet...',
      s3ResultatLabel: 'Résultat principal attendu',
      s3AutreResultatPh: 'Autre résultat attendu...',
      s3SuccesLabel: 'À quoi ressemble le succès pour vous dans 6 mois ?',
      s3SuccesPh: 'Décrivez votre vision du succès...',

      s4Title: '4. Cible & Positionnement',
      s4ClientsLabel: 'Vos clients idéaux',
      s4AutresCiblesPh: 'Autre type de client...',
      s4ZoneGeoLabel: 'Zone géographique ciblée',
      s4ConcurrentsLabel: 'Vos 3 principaux concurrents',
      s4ConcurrentsPh: 'Noms ou sites web de vos concurrents',
      s4DifferentiationLabel: "Ce qui vous différencie d'eux",
      s4DifferentiationPh: 'Vos avantages concurrentiels',
      s4TonLabel: 'Ton souhaité',

      // Step 3
      s5Title: '5. Site Internet',
      s5SiteActuelLabel: 'Lien du site actuel (si existant)',
      s5SiteActuelPh: 'https://...',
      s5NombrePagesLabel: 'Nombre de pages estimé',
      s5NombrePagesPh: 'Ex: 5 pages',
      s5PagesLabel: 'Pages souhaitées',
      s5AutrePagePh: 'Autre page...',
      s5OptionsLabel: 'Options supplémentaires',
      s5DelaiLabel: 'Délais souhaités pour la mise en ligne',
      s5DelaiPh: 'Ex: 2 mois, avant le 1er juillet...',

      s6Title: '6. Contenu & Rédaction',
      s6TextesLabel: 'Textes',
      s6MediasLabel: 'Médias disponibles',
      s6TonRedactionLabel: 'Ton de rédaction souhaité',
      s6TonRedactionPh: 'Ex: professionnel et accessible, dynamique, formel...',

      // Step 4
      s7Title: '7. Branding & Charte Graphique',
      s7LogoLabel: 'Logo',
      s7CharteLabel: 'Charte graphique',
      s7CouleursLabel: 'Couleurs actuelles ou souhaitées',
      s7CouleursPh: 'Ex: bleu marine, doré, blanc...',
      s7TypographiesLabel: 'Typographies utilisées',
      s7TypographiesPh: 'Ex: Montserrat, Georgia...',
      s7AmbianceLabel: 'Ambiance visuelle souhaitée',
      s7SitesLabel: '3 sites que vous aimez visuellement (et pourquoi)',
      s7Site1Ph: 'Site 1 : URL et raison',
      s7Site2Ph: 'Site 2 : URL et raison',
      s7Site3Ph: 'Site 3 : URL et raison',

      s8Title: '8. SEO — Référencement Naturel',
      s8SituationLabel: 'Situation actuelle',
      s8ObjectifsLabel: 'Objectifs SEO',
      s8MotsClesLabel: 'Mots-clés prioritaires',
      s8MotsClesPh: 'Ex: agence web Paris, création site e-commerce, référencement SEO Lyon...',

      // Step 5
      s9Title: '9. Automatisation & Intelligence Artificielle',
      s9Note: "Cochez les fonctionnalités qui vous intéressent — pas besoin d'expertise technique !",
      s9AutomatisationLabel: 'Automatisation',
      s9SurSiteLabel: 'Sur le site',
      s9IntegrationsLabel: 'Intégration avec vos outils',
      s9AutreIntegrationPh: 'Autre outil...',
      s9FamiliariteLabel: "Niveau de familiarité avec l'IA",

      s10Title: '10. Réseaux Sociaux & Communication',
      s10ReseauxLabel: 'Réseaux actifs',
      s10AutreReseauPh: 'Autre réseau...',
      s10BesoinsLabel: 'Besoins',
      s10FrequenceLabel: 'Fréquence de publication souhaitée',
      s10FrequencePh: 'Ex: 3 posts/semaine, quotidien...',

      // Step 6
      s11Title: '11. Budget & Organisation',
      s11BudgetLabel: 'Budget global alloué au projet',
      s11DelaisLabel: 'Délais souhaités',
      s11DelaisPh: 'Ex: dans 3 mois, avant été 2025...',
      s11InterlocuteurLabel: 'Interlocuteur principal (nom + contact)',
      s11InterlocuteurPh: 'Nom et coordonnées',
      s11ExperienceLabel: 'Expérience avec des agences',
      s11MauvaisesPh: 'Décrivez ce que vous souhaitez éviter...',

      s12Title: '12. Espace Libre',
      s12Label: "Ajoutez ici tout ce qui n'a pas été couvert et qui nous aiderait à mieux vous accompagner",
      s12Ph: 'Vos remarques, questions, informations complémentaires...',

      summaryTitle: 'Résumé de votre questionnaire',
      summaryClient: 'Client',
      summaryEmail: 'Email',
      summarySecteur: 'Secteur',
      summaryProjet: 'Projet',
      summaryBudget: 'Budget',
      summaryDelai: 'Délai',

      valeurs: ['Excellence & qualité de service', 'Soin & sécurité', 'Réactivité', 'Accompagnement humain / émotionnel', 'Innovation'],
      visuels: ["Photos de l'équipe", 'Photos du matériel / locaux', 'Vidéos', 'Témoignages clients', 'Aucun — à prévoir'],
      typeProjet: ["Création d'un nouveau site", 'Refonte du site existant', 'Optimisation du site actuel'],
      resultats: ['Générer des leads / devis', 'Augmenter la visibilité Google', 'Renforcer la notoriété / branding', 'Vente en ligne', 'Automatiser des tâches'],
      cibles: ['Particuliers', 'Professionnels / TPE-PME', 'Grandes entreprises'],
      zoneGeoOptions: ['Locale / régionale', 'Nationale', 'Internationale'],
      tons: ['Sérieux / institutionnel', 'Chaleureux / humain', 'Premium / luxe', 'Moderne / dynamique', 'Accessible / grand public'],
      pagesSouhaitees: ['Accueil', 'À propos / Histoire', 'Services / Offres', 'Réalisations / Portfolio', 'Témoignages', 'Blog / Actualités', 'Contact', 'Formulaire de devis en ligne'],
      optionsSupp: ['Site multilingue', 'Espace client / membre', 'Prise de rendez-vous en ligne', 'Chat en ligne', 'Nom de domaine déjà existant'],
      textesOptions: ["J'ai des textes existants à réutiliser", 'Je souhaite que Nexia Digital rédige les contenus', 'Mix des deux'],
      medias: ['Photos professionnelles', 'Photos personnelles', 'Vidéos', 'Témoignages clients', 'Aucun — tout est à créer'],
      logoOptions: ['Logo existant — satisfait', 'Logo existant — à moderniser', 'Pas de logo — à créer'],
      charteOptions: ['Charte existante à respecter', 'Pas de charte — à créer'],
      ambiances: ['Épuré / minimaliste', 'Coloré / dynamique', 'Moderne / tech', 'Élégant / premium', 'Chaleureux / humain'],
      situationSEO: ['Visible sur Google', 'Peu visible', 'Pas de présence Google', 'Google Business Profile existant'],
      objectifsSEO: ['Apparaître sur des mots-clés locaux', 'Référencement national', 'Création / optimisation Google Business', 'Suivi mensuel des performances'],
      automatisation: ['Envoi automatique de devis', 'Relances clients automatiques', 'Prise de rendez-vous automatisée', 'Synthèse automatique de réunions clients', 'Génération de contenus (emails, posts, fiches...)'],
      surSite: ['Chatbot / assistant virtuel', 'Formulaire intelligent (pré-qualification client)', 'FAQ automatisée'],
      integrations: ['CRM (HubSpot, Salesforce...)', 'Agenda / Google Calendar', 'Email (Gmail, Outlook...)'],
      familiariteOptions: ["Débutant — j'aimerais en savoir plus", "Intermédiaire — j'utilise déjà quelques outils", "Avancé — j'ai des besoins précis"],
      reseaux: ['Instagram', 'Facebook', 'LinkedIn', 'TikTok', 'YouTube'],
      besoinsRS: ['Gestion des réseaux sociaux', 'Création de contenus visuels', 'Newsletter', 'Campagnes publicitaires (Meta Ads, Google Ads)'],
      budgets: ['Moins de 1 000 €', '1 000 € – 3 000 €', '3 000 € – 6 000 €', '6 000 € – 10 000 €', '+ de 10 000 €', 'À définir ensemble'],
      experienceOptions: ['Première collaboration avec une agence', 'Expériences passées positives', 'Mauvaises expériences à éviter'],
      experienceAvoid: 'Mauvaises expériences à éviter',
    },

    partners: {
      eyebrow: "Apporteurs d'Affaires",
      titlePre: 'Recommandez nos services.',
      titleEm: "Jusqu'à 15%",
      titlePost: 'de commission sur chaque client signé.',
      desc: "Nexia Digital recrute des apporteurs d'affaires indépendants. Vous nous présentez une entreprise qui a besoin d'un site, de développement sur-mesure, de SEO, de design, d'une solution IA ou d'une stratégie digitale — nous nous occupons du reste. 12% de commission de base, 15% dès le 4e client apporté dans l'année.",
      point1: '12% du CA HT encaissé, 15% dès le 4e client/an',
      point2: 'Paiement sous 30 jours après encaissement client',
      point3: 'Aucun quota, aucune exclusivité, suivi sur 12 mois',
      ctaPrimary: "Devenir apporteur d'affaires",
      ctaSecondary: 'Une question ? Contactez-nous',
      b1Title: '12% de base, sans plafond',
      b1Desc:  "Commission de 12% sur le chiffre d'affaires HT encaissé, quel que soit le montant de la mission.",
      b2Title: '15% dès le 4e client',
      b2Desc:  "Bonus fidélité : votre taux passe à 15% à partir du 4e client apporté dans l'année.",
      b3Title: 'Paiement sous 30 jours',
      b3Desc:  'Dès que Nexia Digital a encaissé la facture client, votre commission est virée.',
      b4Title: 'Suivi sur 12 mois',
      b4Desc:  'Avenants, renouvellements et prestations complémentaires restent commissionnés.',
    },

    cta: {
      eyebrow: 'Prêt à Décoller ?',
      titlePre: 'Votre Projet Digital Mérite',
      titleEm: 'la Meilleure Équipe',
      desc: "Obtenez un devis gratuit et personnalisé en moins de 24 h. Notre équipe d'experts en digital analyse vos besoins et vous propose une stratégie sur-mesure pour atteindre vos objectifs et développer votre visibilité en ligne.",
      f1: 'Devis gratuit & sans engagement',
      f2: 'Réponse en moins de 24h',
      f3: 'Accompagnement personnalisé',
      ctaMain: 'Demander un Devis Gratuit',
      panelEyebrow: 'Délai de réponse garanti',
      h1Title: 'Livraison Rapide', h1Sub: 'Délais respectés à 100%',
      h2Title: '98% Satisfaction',  h2Sub: 'Clients qui recommandent',
      h3Title: 'Innovation',        h3Sub: 'Technologies de pointe',
    },

    navbar: {
      home: 'Accueil',
      about: 'À Propos',
      services: 'Services',
      portfolio: 'Portfolio',
      apporteurs: 'Apporteurs',
      contact: 'Contact',
      cta: 'Demander un Devis',
    },

    about: {
      // Hero
      heroEyebrow: 'Notre Histoire',
      heroTitlePre: 'Passionnés du Digital,',
      heroTitleEm: 'Engagés pour Votre Succès',
      heroDesc: 'Nexia Digital est une agence de communication full-service nouvelle génération. Notre mission : accompagner les entreprises dans leur transformation digitale avec créativité, expertise et résultats mesurables.',
      heroCta1: 'Travailler Avec Nous',
      heroCta2: 'Voir Nos Réalisations',
      // Mission / Vision / Valeurs
      missionTitle: 'Notre Mission',
      missionText: "Démocratiser l'excellence digitale en offrant des solutions créatives et technologiques de niveau international, accessibles aux entreprises de toutes tailles. Nous transformons les défis digitaux en opportunités de croissance.",
      missionP1: 'Stratégies sur mesure pour chaque client',
      missionP2: 'Technologies de pointe et meilleures pratiques',
      missionP3: 'Résultats mesurables et transparents',
      visionTitle: 'Notre Vision',
      visionText: "Devenir la référence des agences digitales en Afrique du Nord — reconnue pour son excellence créative, son expertise technologique et l'impact concret qu'elle génère pour ses clients. Nous croyons en un digital éthique, inclusif et porteur de sens.",
      visionP1: 'Leadership en innovation digitale internationale',
      visionP2: 'Expansion sur les marchés africains et européens',
      visionP3: 'Contribution au rayonnement du digital mondial',
      valuesTitle: 'Nos Valeurs',
      valuesText: 'Excellence, intégrité, créativité et partenariat sont les piliers sur lesquels repose chaque action de Nexia Digital. Nous ne livrons pas juste des projets, nous construisons des succès durables.',
      valuesP1: 'Qualité sans compromis sur chaque livrable',
      valuesP2: 'Transparence totale dans notre communication',
      valuesP3: 'Innovation continue et veille technologique',
      // Process
      processEyebrow: 'Notre Méthode',
      processTitlePre: 'Notre',
      processTitleEm: 'Processus de Travail',
      step1Title: 'Découverte & Brief',
      step1Desc:  'Nous prenons le temps de comprendre votre projet, vos objectifs et votre cible. Un brief complet est établi pour cadrer la mission.',
      step2Title: 'Stratégie & Conception',
      step2Desc:  "Notre équipe élabore une stratégie sur mesure et propose des concepts créatifs alignés avec votre identité de marque.",
      step3Title: 'Création & Développement',
      step3Desc:  "Nos experts passent à l'action : design, développement, production de contenu — chaque livrable est réalisé avec soin et précision.",
      step4Title: 'Validation & Tests',
      step4Desc:  'Chaque étape est validée avec vous. Nous effectuons des tests rigoureux pour garantir la qualité et la conformité de chaque livrable.',
      step5Title: 'Lancement & Livraison',
      step5Desc:  'Votre projet est mis en ligne ou livré selon les délais convenus. Nous assurons un lancement sans accroc.',
      step6Title: 'Suivi & Optimisation',
      step6Desc:  "Notre accompagnement ne s'arrête pas à la livraison. Nous analysons les performances et optimisons en continu pour maximiser vos résultats.",
      // Portfolio PDF
      pdfEyebrow: 'Notre Portfolio · 2026',
      pdfTitlePre: 'Découvrez notre',
      pdfTitleEm: 'présentation complète',
      pdfDesc: 'Un document complet qui rassemble qui nous sommes, notre expertise et nos plus belles réalisations en branding, développement web, supports print et social media. Consultez-le en ligne ou téléchargez-le pour le partager.',
      pdfCta1: 'Consulter la présentation',
      pdfCta2: 'Télécharger le PDF',
      pdfBadge: 'Portfolio PDF',
      // CTA Questionnaire
      questEyebrow: 'Parlons de votre projet',
      questTitlePre: 'Prêt à démarrer',
      questTitleEm: "l'aventure avec nous ?",
      questDesc: 'Remplissez notre questionnaire client et recevez une proposition personnalisée adaptée à vos besoins et à votre budget.',
      questCta: 'Remplir le questionnaire',
    },

    footer: {
      tagline: "Votre partenaire digital de confiance. Nous transformons vos idées en expériences numériques exceptionnelles pour propulser votre marque vers l'avenir.",
      servicesTitle: 'Nos Services',
      navigationTitle: 'Navigation',
      contactTitle: 'Contact',
      navHome: 'Accueil',
      navAbout: 'À Propos',
      navPortfolio: 'Portfolio',
      navContact: 'Contact',
      navDevis: 'Demander un Devis',
      navApporteurs: "Devenir Apporteur d'Affaires",
      rights: 'Tous droits réservés.',
      legal: 'Mentions légales',
      madeWith: 'Conçu avec',
      madeBy: 'par Nexia Digital',
      scrollTop: 'Retour en haut',
      // Services labels
      srvWeb: 'Développement Web & Mobile',
      srvDesign: 'Graphisme & Design',
      srvCommunity: 'Community Management',
      srvAudio: 'Audiovisuel & Motion Design',
      srvMarketing: 'Marketing Digital',
      srvStrategy: 'Stratégie & Consulting',
      srvIA: 'Solutions IA Sur Mesure',
      srvSeo: 'SEO & SEA',
    },

    testimonials: {
      eyebrow: 'Avis Clients',
      titlePre: 'Ce Que Disent',
      titleEm: 'Nos Partenaires',
      desc: "La satisfaction de nos clients est notre meilleure récompense. Découvrez leurs retours d'expérience avec Nexia Digital.",
      verifiedF: 'Cliente vérifiée',
      verifiedM: 'Client vérifié',
      reviewsCount: '{count} avis',
      seeOnTrustpilot: 'Voir sur Trustpilot',
      seeAllReviews: 'Voir tous les avis sur Trustpilot',
      trust1: '100% Confidentiel',
      trust2: 'Partenariats durables',
      trust3: 'ROI garanti',
      trust4: 'Support 7j/7',
      // Témoignages (rôles personnalisés)
      role1: 'Président du CO des CDM de Scrabble 2026',
      // Titres + textes des avis
      t1Title: 'Tunis 2026 – 54ᵉˢ championnats du monde de Scrabble francophone',
      t1Text:  "Dans le cadre de l'organisation des Championnats du monde de Scrabble francophone à Tunis en juillet prochain, nous avons mandaté l'agence Nexia-Takt pour la réalisation du dossier de présentation et partenariat ainsi que pour l'actualisation du site internet des CDM. Professionnalisme et disponibilité ont conduit au succès de cette collaboration pour cette étape importante. Merci à tous les contributeurs à ces belles réalisations.",
      t2Title: 'Professionnalisme, le travail effectué…',
      t2Text:  "Tout d'abord, le travail effectué avec un professionnalisme, c'est magnifique. Ils sont à l'écoute du client, réactifs, vraiment disponibles. Ils essaient toujours de trouver une solution et proposent au client ce qui est le mieux pour lui. Je me suis sentie écoutée, ils étaient très attentifs à mes attentes et ont complètement rempli le cahier des charges. Je ferai une publicité pour cette entreprise tout le temps, car c'est devenu très rare d'avoir des entreprises qui sont à l'écoute du client. Très belle expérience et je remercie de travailler avec eux.",
      t3Title: 'Une équipe efficace et très professionnelle',
      t3Text:  'Une équipe efficace et très professionnelle. Respecte les délais et délivre un travail de qualité. 🙏🏽🙏🏽🙏🏽🙏🏽',
      t4Title: 'Relooking de site web',
      t4Text:  "Nous avons fait appel à l'agence pour doper notre site web des championnats du monde de scrabble francophone qui doit se dérouler à Tunis en juillet 2026. Leur personnel est compétent et fort sympathique. Nos contacts ont été très fructueux. Nous sommes très contents du résultat et je recommande cette agence.",
    },
  },

  // ─── DE ─────────────────────────────────────────────────────────────
  de: {
    language: {
      label: 'Sprache',
      fr: 'Französisch',
      de: 'Deutsch',
    },
    languagePopup: {
      title: 'Wählen Sie Ihre Sprache',
      subtitle: 'Choisissez votre langue.',
      french: 'Französisch',
      german: 'Deutsch',
      continue: 'Weiter',
    },

    logos: {
      label: 'Beherrschte Technologien und Plattformen',
    },

    hero: {
      titlePre: 'Verwirklichen Sie Ihre',
      titleEm: 'digitale Vision',
      titlePost: 'mit Nexia',
      desc: 'Nexia Digital, eine Digitalagentur in Paris und Île-de-France, begleitet Sie bei der Erstellung leistungsstarker Websites, der Entwicklung mobiler Anwendungen, im Grafikdesign, Community Management und in digitalen Marketingstrategien — für mehr Sichtbarkeit und messbare Ergebnisse.',
      ctaPrimary: 'Projekt starten',
      ctaSecondary: 'Portfolio ansehen',
      proof: {
        p1Value: 'Full-Service', p1Label: 'Digitalagentur',
        p2Value: 'KI-nativ',     p2Label: 'Integrierte Lösungen',
        p3Value: 'Maßgeschneidert', p3Label: 'Jedes Projekt',
        p4Value: '24h',          p4Label: 'Reaktionszeit',
      },
    },

    aboutMini: {
      eyebrow: 'Über Nexia Digital',
      titlePre: 'Die Digitalagentur, die',
      titleEm: 'den Unterschied macht',
      p1: 'Gegründet von Digital-Enthusiasten, ist Nexia Digital eine Agentur für digitale Kommunikation in Paris, spezialisiert auf Webentwicklung, SEO, digitales Marketing und Branding. Unsere Mission: Unternehmen mit Kreativität, Expertise und Engagement in ihrer digitalen Transformation zu begleiten.',
      p2: 'Als ambitionierte Webagentur setzen wir unsere Leidenschaft und unser Know-how für Ihr digitales Wachstum ein — mit maßgeschneiderten, kreativen und ergebnisorientierten Lösungen.',
      point1: 'Multidisziplinäres Team mit über 15 Experten an Ihrer Seite',
      point2: 'Agile Vorgehensweise und bewährte Methodik',
      point3: 'Transparentes Reporting und regelmäßige KPI-Auswertung',
      point4: 'Technischer Support 7 Tage die Woche',
      cta: 'Mehr erfahren',
      value1Title: 'Ergebnisorientiert',
      value1Desc:  'Jede Aktion wird gemessen und für maximalen ROI optimiert.',
      value2Title: 'Kontinuierliche Innovation',
      value2Desc:  'Wir integrieren die neuesten Technologien und digitalen Trends.',
      value3Title: 'Nachhaltige Partnerschaft',
      value3Desc:  'Wir bauen langfristige Beziehungen zu unseren Kunden auf.',
      value4Title: 'Reaktionsfähigkeit',
      value4Desc:  'Ein verfügbares und proaktives Team, das auf Ihre Bedürfnisse eingeht.',
      badgeNumber: '100%',
      badgeStrong: 'Zufriedene Kunden',
      badgeText:   'Im Dienst Ihres digitalen Wachstums',
    },

    youtube: {
      eyebrow: 'Unsere Vision',
      titlePre: 'Entdecken Sie',
      titleEm: 'Nexia Digital',
      titlePost: 'im Video',
      desc: 'Eine Agentur, konzipiert, um Ihre Marke ins digitale Zeitalter zu katapultieren.',
      approach1Title: 'Kreativität', approach1Desc: 'Ideen, die herausstechen',
      approach2Title: 'Technologie', approach2Desc: 'Leistungsstarke & moderne Tools',
      approach3Title: 'Data-driven', approach3Desc: 'Datenbasierte Entscheidungen',
      approach4Title: 'Wachstum',    approach4Desc: 'Ihre Marke vorantreiben',
    },

    services: {
      eyebrow: 'Unsere Expertisen',
      titlePre: 'Maßgeschneiderte',
      titleEm: 'Lösungen',
      titlePost: 'für Ihr Business',
      desc: 'Von der Strategie bis zur Umsetzung — wir decken alle digitalen Bereiche ab.',

      pageEyebrow: 'Unsere Expertisen',
      pageTitlePre: 'Ein vollständiges Ökosystem',
      pageTitleEm: 'digitaler Leistungen',
      pageDesc: 'Ob Sie eine Web-Präsenz, eine starke visuelle Identität, eine Social-Media-Strategie oder eine wirkungsvolle Werbekampagne benötigen — Nexia Digital ist Ihr All-in-One-Partner.',
      learnMore: 'Mehr erfahren',
      discover: 'Entdecken',
      seeAll: 'Alle Leistungen ansehen',

      seoTitle: 'Unsere Leistungen — Nexia Digital | Digitalagentur',
      seoDesc: 'Entdecken Sie alle Leistungen von Nexia Digital: Web- & Mobile-Entwicklung, Grafik, Community Management, Motion Design, Digital Marketing und Beratung.',
      seoKeywords: 'Digitalagentur Leistungen, Web-Entwicklung, Grafik, Community Management, Motion Design, SEO, Digital Marketing',

      detail: {
        breadcrumbHome: 'Startseite',
        breadcrumbServices: 'Leistungen',
        ctaQuote: 'Angebot erhalten',
        whyChoosePre: 'Warum Nexia Digital für',
        whyChooseSuffix: 'wählen?',
        teamLine: 'Unser Expertenteam vereint Kreativität, technische Expertise und ein tiefes Verständnis Ihrer Bedürfnisse, um Lösungen zu liefern, die echte Ergebnisse erzielen. Jedes Projekt ist einzigartig, jede Strategie maßgeschneidert.',
        deliveryTitle: 'Was wir liefern',
        processTitle: 'Unser Prozess',
        step1Title: 'Entdeckung',
        step1Desc:  'Analyse Ihrer Bedürfnisse, Ziele und des Wettbewerbsumfelds.',
        step2Title: 'Strategie',
        step2Desc:  'Ausarbeitung eines maßgeschneiderten Ansatzes und detaillierten Aktionsplans.',
        step3Title: 'Umsetzung',
        step3Desc:  'Produktion durch unser Expertenteam mit rigorosem Tracking.',
        step4Title: 'Lieferung',
        step4Desc:  'Deployment, Schulung und Begleitung nach dem Launch.',
        sidebarTitle: 'Ihr Projekt starten',
        sidebarDesc:  'Erhalten Sie ein kostenloses individuelles Angebot in 24h. Unser Team analysiert Ihre Bedürfnisse und schlägt eine passende Lösung vor.',
        sidebarCta1:  'Angebot anfordern',
        sidebarCta2:  'Kontakt aufnehmen',
        sidebarInfo3: 'Antwort in weniger als 24h',
        keywordsTitle: 'Schlüsselwörter',
        otherTitlePre: 'Unsere weiteren',
        otherTitleEm:  'Leistungen',
      },

      items: {
        'developpement-web-mobile': {
          title: 'Web- & Mobile-Entwicklung',
          shortTitle: 'Web & Mobile',
          tagline: 'Maßgeschneiderte digitale Lösungen, die Ihr Wachstum vorantreiben',
          description: 'Nexia Digital konzipiert und entwickelt leistungsstarke Showcase-Websites, E-Commerce-Plattformen und mobile iOS-/Android-Anwendungen, SEO-optimiert und für alle Geräte geeignet. Wir setzen modernste Technologien ein, um Ihnen eine unvergleichliche digitale Präsenz zu bieten.',
          features: [
            'Showcase- und responsive Corporate-Websites',
            'Leistungsstarke E-Commerce-Anwendungen (WooCommerce, Shopify, Custom)',
            'Mobile Apps für iOS & Android (React Native, Flutter)',
            'PWA, Progressive Web Apps',
            'CMS-Integration (WordPress, Strapi, Sanity)',
            'Performance-Optimierung und Core Web Vitals',
            'REST- & GraphQL-APIs',
            'Wartung & technischer Support',
          ],
        },
        'design-graphique': {
          title: 'Grafik & Design',
          shortTitle: 'Grafik',
          tagline: 'Verleihen Sie sich eine starke visuelle Identität, die im Gedächtnis bleibt',
          description: 'Unser Designstudio kreiert wirkungsvolle visuelle Identitäten, Kommunikationsmittel für Print und Digital sowie UI/UX-Oberflächen, die konvertieren. Jedes Pixel ist darauf ausgelegt, die DNA Ihrer Marke widerzuspiegeln und Ihre Zielgruppe zu begeistern.',
          features: [
            'Kreation visueller Identität & Logo',
            'Vollständiger Brand Guide',
            'UI/UX-Design für Web und Mobile',
            'Print-Medien (Flyer, Broschüren, Plakate)',
            'Verpackung und Produktdesign',
            'Infografiken und Datenvisualisierung',
            'Social-Media-Templates',
            'Brand Guidelines',
          ],
        },
        'community-management': {
          title: 'Community Management',
          shortTitle: 'Community',
          tagline: 'Bauen Sie eine engagierte Community rund um Ihre Marke auf',
          description: 'Unser Team aus erfahrenen Community Managern betreut Ihre Präsenz auf Facebook, Instagram, LinkedIn, TikTok und X. Wir erstellen strategische Inhalte, aktivieren Ihre Community und steigern Ihre digitale Bekanntheit mit datenbasierten Strategien.',
          features: [
            'Social-Media-Content-Strategie',
            'Erstellung und Planung von Posts',
            'Betreuung von Facebook, Instagram, LinkedIn, TikTok, X',
            'Community-Aktivierung und Moderation',
            'Bewertungs- und Online-Reputation-Management',
            'Monatliches Reporting und Analytics',
            'Wettbewerbsbeobachtung',
            'Digitales Krisenmanagement',
          ],
        },
        'audiovisuel-motion-design': {
          title: 'Audiovisuell & Motion Design',
          shortTitle: 'Motion Design',
          tagline: 'Visuelle Inhalte, die fesseln und konvertieren',
          description: 'Nexia Digital produziert Corporate-Videos, Werbespots, Motion Graphics und 2D/3D-Animationen, die Ihre Marke zum Leben erwecken. Vom Dreh bis zur Postproduktion übernehmen wir Ihre gesamte audiovisuelle Produktion.',
          features: [
            'Corporate- und Institutionsvideoproduktion',
            'TV- und Digital-Werbespots',
            'Motion Graphics und 2D/3D-Animationen',
            'Tutorials und Erklärvideos (Explainer Videos)',
            'Reels und Kurzformate für Social Media',
            'Intro- & Outro-Sequenzen für YouTube',
            'Untertitelung und Postproduktion',
            'Drohnen- und Luftaufnahmen',
          ],
        },
        'marketing-digital': {
          title: 'Digitales Marketing & Werbung',
          shortTitle: 'Digitales Marketing',
          tagline: 'Marketingstrategien, die einen messbaren ROI generieren',
          description: 'Maximieren Sie Ihren Return on Investment mit unseren integrierten Digital-Marketing-Strategien: SEO, Google Ads, Meta Ads, E-Mail-Marketing und Growth Hacking. Wir steuern Ihre Kampagnen zu 100% datenbasiert, um Ihren ROI zu maximieren.',
          features: [
            'Suchmaschinenoptimierung SEO (On-Page & Off-Page)',
            'Google Ads (Search, Display, Shopping)',
            'Meta-Ads-Kampagnen (Facebook & Instagram)',
            'E-Mail-Marketing und Automatisierung',
            'Content-Strategie und Inbound-Marketing',
            'Performance-Analyse und Reporting',
            'Conversion-Rate-Optimierung (CRO)',
            'Growth Hacking und Kundenakquise',
          ],
        },
        'strategie-digitale': {
          title: 'Strategie & Beratung',
          shortTitle: 'Beratung',
          tagline: 'Ein Expertenblick, um Ihre digitale Transformation zu beschleunigen',
          description: 'Unsere Strategieberater begleiten Sie bei der Definition und Umsetzung Ihrer digitalen Transformation. Audit, Roadmap, Positionierungsberatung — wir führen Sie mit ganzheitlichem Blick und anerkannter Branchenexpertise.',
          features: [
            'Umfassendes Digital-Audit',
            'Strategie zur digitalen Transformation',
            'Positionierungs- und Branding-Beratung',
            'Wettbewerbsanalyse und Benchmarking',
            'Integrierter Kommunikationsplan',
            'Team-Schulung und -Coaching',
            'KPIs und strategisches Dashboard',
            'Begleitung und Post-Implementation-Tracking',
          ],
        },
        'solutions-ia-sur-mesure': {
          title: 'Maßgeschneiderte KI-Lösungen',
          shortTitle: 'KI-Intelligenz',
          tagline: 'Künstliche Intelligenzen, die 24/7 für Sie arbeiten',
          description: 'Nexia Digital konzipiert und integriert maßgeschneiderte KI-Lösungen, um Ihre Prozesse zu automatisieren, Ihr Marketing zu boosten und außergewöhnliche Kundenerlebnisse zu bieten. Von Conversational Agents bis zu prädiktiver Analytik — wir stellen die KI in den Dienst Ihres Wachstums.',
          features: [
            'KI-Conversational-Agent: intelligente virtuelle Assistenten',
            'Fortgeschrittene KI-Chatbots: automatisierte Messaging-Lösungen',
            'KI-Automatisierung: intelligente Workflows und CRM-Integration',
            'Prädiktive Analytik: fortschrittliche Auswertungen mit Machine Learning',
            'KI-Marketing: vollständige KI-Digitalmarketing-Suite',
            'Automatische Content-Generierung (E-Mails, Posts, Produktblätter)',
            'Kunden-Vorqualifizierung über intelligente Formulare',
            'KI-API-Integration (OpenAI, Claude, Gemini…)',
          ],
        },
        'seo-sea': {
          title: 'SEO & SEA',
          shortTitle: 'SEO & SEA',
          tagline: 'Dominieren Sie Google in organischer und bezahlter Suche',
          description: 'Nexia Digital konzipiert und steuert leistungsstarke SEO- und SEA-Strategien, um Ihre Google-Sichtbarkeit zu maximieren. Von langfristiger organischer Suche bis zu Google-Ads-Kampagnen mit hohem ROI — wir kombinieren beide Hebel, um Ihre qualifizierte Traffic-Akquise zu steigern und einen konstanten Lead-Fluss zu generieren.',
          features: [
            'Umfassendes SEO-Audit (technisch, On-Page, Off-Page)',
            'Optimierung der organischen Suche & Content',
            'Lokales SEO & Google Business Profile',
            'Netlinking & Backlink-Strategie',
            'Google-Ads-Kampagnen (Search, Display, Shopping, YouTube)',
            'Bing-Ads-Kampagnen & Retargeting',
            'KPI-Tracking und detailliertes Monatsreporting',
            'A/B-Testing & Conversion-Rate-Optimierung',
          ],
        },
      },
    },

    portfolio: {
      eyebrow: 'Unser Portfolio',
      titlePre: 'Unsere neuesten',
      titleEm: 'Projekte',
      desc: 'Eine Auswahl von Projekten, die wir mit Leidenschaft für unsere Kunden umgesetzt haben.',
      emptyTitle: 'Projekte bald verfügbar',
      emptyDesc: 'Unser Team arbeitet daran, unsere Realisierungen online zu stellen. Schauen Sie bald wieder vorbei!',
      visitLabel: 'Website besuchen',

      seoTitle: 'Portfolio: Projekte von Nexia Digital',
      seoDesc: 'Entdecken Sie das Portfolio unserer Digitalagentur Nexia Digital. Web-, Design- und Marketingprojekte für unsere Kunden in Frankreich.',
      seoKeywords: 'Portfolio Digitalagentur, Web-Realisierungen, Designprojekte, mobile Anwendungen',
      pageEyebrow: 'Portfolio',
      pageTitlePre: 'Unsere Projekte',
      pageTitleEm: 'die den Unterschied machen',
      pageDesc: 'Jedes Projekt ist eine Geschichte aus Zusammenarbeit, Kreativität und konkreten Ergebnissen. Sehen Sie, wie wir unseren Kunden helfen, ihren digitalen Markt zu dominieren.',
      cardCta: 'Projekt ansehen',
      visitSite: 'Website besuchen',

      pdfEyebrow: '— Unser Portfolio',
      pdfTitle: 'Portfolio Nexia Digital · 2026',
      pdfDownload: 'Herunterladen',
      pdfFullscreen: 'Vollbild',
      pdfHint: 'Klicken Sie auf die Seitenecken oder verwenden Sie die ← → Buttons zum Blättern.',
    },

    notfound: {
      seoTitle: 'Seite nicht gefunden — Nexia Digital',
      title: 'Seite nicht gefunden',
      desc: 'Ups! Die gesuchte Seite existiert nicht oder wurde verschoben. Keine Sorge — wir bringen Sie zurück auf den richtigen Weg.',
      home: 'Zurück zur Startseite',
      back: 'Vorherige Seite',
      explore: 'Oder entdecken Sie:',
      services: 'Unsere Leistungen',
      portfolio: 'Portfolio',
      contact: 'Kontakt',
      devis: 'Angebot anfordern',
    },

    roue: {
      seoTitle: 'Glücksrad — Nexia Digital · Stand Scrabble-Weltmeisterschaft Tunis 2026',
      seoDesc: 'Nexia Digital erwartet Sie am Stand der 54. Weltmeisterschaft im französischsprachigen Scrabble in Tunis. Drehen Sie unser Rad und gewinnen Sie Rabatte und kostenlose Digital-Services.',

      event: {
        location: 'Nexia-Digital-Stand · Tunis 2026',
        title: 'Besuchen Sie uns bei der 54. Weltmeisterschaft im französischsprachigen Scrabble',
        desc: 'Nexia Digital ist stolzer Partner der Scrabble-Weltmeisterschaft Tunis 2026. Kommen Sie an unseren Stand, drehen Sie das Rad und gewinnen Sie exklusive Rabatte und kostenlose Digital-Leistungen!',
      },

      eyebrow: 'Gewinnspiel',
      titlePre: 'Versuchen Sie',
      titleEm: 'Ihr Glück',
      subtitle: 'Füllen Sie dieses Formular aus, um teilzunehmen. Drehen Sie das Rad und gewinnen Sie einen Rabatt oder eine Leistung von Nexia Digital!',

      prizes: {
        site40Line1: 'auf eine Website',
        site40Sub: 'Premium-Website',
        charte35Line1: 'auf Corporate Design',
        charte35Sub: 'Logo + visuelle Identität',
        site20Line1: 'auf eine Website',
        site20Sub: 'Professionelle Showcase-Website',
        charte15Line1: 'auf Corporate Design',
        cadeauTitle: 'ÜBERRASCHUNG',
        cadeauSub: '',
        retryTitle: 'ZWEITE CHANCE',
        retrySub: 'Drehen Sie das Rad erneut!',
      },

      secondChanceMsg: 'Sie haben eine zweite Chance! Drehen Sie das Rad erneut, um Ihren Gewinn zu entdecken.',
      retryBtn: 'Rad erneut drehen',

      firstName: 'Vorname',
      lastName: 'Nachname',
      phone: 'Telefon',
      email: 'E-Mail',
      projet: 'Ihr Projekt',
      notes: 'Weitere Notizen',
      phFirstName: 'Jan',
      phLastName: 'Müller',
      phPhone: '+49 151 23456789',
      phEmail: 'jan.mueller@email.de',
      phProjet: 'z. B. Website-Relaunch, SEO-Kampagne, Logo-Design…',
      phNotes: 'Erzählen Sie uns mehr über Ihr Projekt oder Ihre Erwartungen',
      submit: 'Absenden und Rad drehen',
      submitting: 'Wird gesendet…',
      legal: 'Mit der Teilnahme stimmen Sie zu, dass Ihre Daten von Nexia Digital verarbeitet werden, um Sie zu Ihrem Gewinn zu kontaktieren.',
      legalLink: 'Mehr erfahren',

      toastReq: 'Vorname, Nachname, Telefon und E-Mail sind erforderlich.',
      toastEmail: 'Ungültige E-Mail-Adresse.',
      toastErr: 'Ein Fehler ist aufgetreten. Bitte erneut versuchen.',

      wheelEyebrow: 'Sie sind dran',
      wheelTitlePre: 'Drehen Sie',
      wheelTitleEm: 'das Rad',
      wheelSubtitle: 'Klicken Sie auf den Button unten, um das Rad zu drehen und Ihren Gewinn zu entdecken!',
      spinBtn: 'Rad drehen',
      spinning: 'Das Rad dreht sich…',

      resultEyebrow: 'Herzlichen Glückwunsch',
      congrats: 'Glückwunsch',
      won: 'Sie haben gewonnen:',
      resultDesc: 'Unser Team wird Sie in Kürze per E-Mail kontaktieren, um Ihnen Ihren Code zu senden oder Ihren Gewinn zu aktivieren. Bis bald!',
      resultCta: 'Über mein Projekt sprechen',
      resultHome: 'Zurück zur Startseite',
      replay: 'Nochmal spielen',
    },

    presentation: {
      seoTitle: 'Präsentation — Nexia Digital · Portfolio 2026',
      seoDesc: 'Entdecken Sie Nexia Digital: Digitalagentur, Branding, Web-Entwicklung, Social Media und mehr. Laden Sie unser Portfolio 2026 (PDF) herunter.',
      ogTitle: 'Präsentation Nexia Digital — Portfolio 2026',
      ogDesc: 'Unsere Expertise in Branding, Web, Design und Marketing — alle Realisierungen in einem Dokument.',

      eyebrow: 'Portfolio 2026',
      titlePre: 'Entdecken Sie',
      titleEm: 'Nexia Digital',
      subtitle: 'Eine ganzheitliche Digitalagentur, die Unternehmen bei ihrer Transformation begleitet. Unser Portfolio versammelt unsere schönsten Realisierungen in Branding, Web-Entwicklung, KI-Lösungen, SEO, Social Media und Print.',
      download: 'PDF herunterladen',
      openFullscreen: 'Im Vollbild öffnen',
      discuss: 'Lassen Sie uns über Ihr Projekt sprechen',

      ctaEyebrow: '— Überzeugt?',
      ctaTitlePre: 'Sprechen wir',
      ctaTitleEm: 'über Ihr Projekt',
      ctaTitlePost: '?',
      ctaDesc: 'Sie haben gesehen, was wir können. Erzählen Sie uns von Ihren Ambitionen. Wir antworten innerhalb von 24 Stunden.',
      ctaQuote: 'Angebot anfordern',
      ctaWrite: 'Schreiben Sie uns',
    },

    contactPage: {
      seoTitle: 'Kontaktieren Sie unsere Digitalagentur in Paris',
      seoDesc: 'Suchen Sie einen Partner für Ihr Webprojekt? Kontaktieren Sie Nexia Digital, Digitalagentur in Paris. Kostenloses Angebot und Antwort in 24h!',

      heroEyebrow: 'Kontaktieren Sie uns',
      heroTitlePre: 'Sprechen wir über',
      heroTitleEm: 'Ihr Projekt',
      heroDesc: 'Eine Idee? Ein Projekt? Eine Frage? Unser Team begleitet Sie. Kontaktieren Sie uns und erhalten Sie eine Antwort innerhalb von 24 Stunden.',

      coordsTitle: 'Unsere Kontaktdaten',
      coordsIntro: 'Wir stehen Ihnen Montag bis Freitag zur Verfügung. Zögern Sie nicht, uns über das Formular, per Telefon oder per E-Mail zu kontaktieren.',
      infoAddressLabel: 'Adresse',
      infoAddressSub: '93260 Les Lilas',
      infoPhoneLabel: 'Telefon',
      infoPhoneSub: 'Erreichbar 9–18 Uhr',
      infoEmailLabel: 'E-Mail',
      infoEmailSub: 'Antwort in weniger als 24h',
      infoScheduleLabel: 'Öffnungszeiten',
      infoScheduleValue: 'Mo – Fr: 9 – 18 Uhr',
      infoScheduleSub: 'Sa: 9 – 13 Uhr',

      quickTitle: 'Schnellzugriff',
      quickCta: 'Kostenloses Angebot anfordern',

      formTitle: 'Senden Sie uns eine Nachricht',
      formNameLabel: 'Vollständiger Name *',
      formNamePh: 'z. B. Jan Müller',
      formEmailLabel: 'E-Mail *',
      formEmailPh: 'ihre@email.com',
      formPhoneLabel: 'Telefon',
      formPhonePh: '+33 X XX XX XX XX',
      formSubjectLabel: 'Betreff',
      formSubjectPh: '— Betreff wählen —',
      formMessageLabel: 'Nachricht *',
      formMessagePh: 'Beschreiben Sie Ihr Projekt oder Ihre Anfrage...',
      formSubmit: 'Nachricht senden',
      formSubmitting: 'Wird gesendet...',

      toastReq: 'Bitte füllen Sie alle Pflichtfelder aus.',
      toastSuccess: 'Nachricht gesendet! Wir antworten innerhalb von 24h.',
      toastError: 'Fehler beim Senden. Bitte erneut versuchen.',

      subjects: [
        'Web- & Mobile-Entwicklung',
        'Grafik & Design',
        'Community Management',
        'Audiovisuell & Motion Design',
        'Digitales Marketing & Werbung',
        'Strategie & Beratung',
        'Maßgeschneiderte KI-Lösungen',
        'SEO & SEA',
        'Angebotsanfrage',
        'Sonstiges',
      ],
    },

    legal: {
      seoTitle: 'Impressum & Datenschutzerklärung — Nexia Digital',
      seoDesc: 'Impressum, Datenschutzerklärung und Informationen zur Cookie-Nutzung der Website Nexia Digital.',

      heroEyebrow: 'Rechtliche Hinweise',
      heroTitlePre: 'Impressum &',
      heroTitleEm: 'Datenschutz',
      lastUpdate: 'Letzte Aktualisierung:',
      toc: 'Inhaltsverzeichnis',
      contactBoxTitle: 'Eine Frage zu Ihren Daten?',
      contactBoxText: 'Kontaktieren Sie unseren Datenschutzbeauftragten unter',

      sections: [
        {
          title: '1. Anbieter der Website',
          content: `Die Website nexia-digital.com wird betrieben von Nexia Digital, Kommunikations- und Digitalmarketing-Agentur.

Sitz: 145 Rue de Noisy-le-Sec, 93260 Les Lilas
E-Mail: contact@nexia-digital.com
Telefon: +33 7 75 21 51 57
Verantwortlich für die Veröffentlichung: Geschäftsführung Nexia Digital`,
        },
        {
          title: '2. Hosting',
          content: `Die Website wird gehostet von Firebase / Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.`,
        },
        {
          title: '3. Urheberrecht',
          content: `Sämtliche Inhalte der Website nexia-digital.com (Texte, Bilder, Grafiken, Logo, Icons, Sounds, Software) sind das ausschließliche Eigentum von Nexia Digital und durch internationale Urheberrechtsgesetze geschützt.

Jede Reproduktion, Darstellung, Änderung, Veröffentlichung, Übertragung oder Verfälschung — ganz oder teilweise — der Website oder ihrer Inhalte, in welcher Form und auf welchem Medium auch immer, ist ohne die ausdrückliche vorherige Genehmigung von Nexia Digital untersagt.`,
        },
        {
          title: '4. Personenbezogene Daten',
          content: `Nexia Digital erhebt personenbezogene Daten über seine Kontakt- und Angebotsformulare. Diese Daten werden ausschließlich zur Beantwortung Ihrer Anfragen und zur Verbesserung unserer Dienstleistungen verwendet.

Gemäß der geltenden Datenschutzgrundverordnung (DSGVO) haben Sie das Recht auf Auskunft, Berichtigung und Löschung Ihrer personenbezogenen Daten.

Um diese Rechte auszuüben, kontaktieren Sie uns unter: contact@nexia-digital.net

Ihre Daten werden niemals an Dritte zu kommerziellen Zwecken weitergegeben, verkauft oder vermietet.`,
        },
        {
          title: '5. Cookies',
          content: `Die Website nexia-digital.com verwendet Cookies zur Verbesserung der Benutzererfahrung und zur Analyse des Datenverkehrs. Cookies sind kleine Textdateien, die auf Ihrem Computer gespeichert werden.

Verwendete Cookie-Typen:
• Essenzielle Cookies: notwendig für das Funktionieren der Website
• Analyse-Cookies: Reichweitenmessung über Firebase Analytics (anonymisiert)
• Präferenz-Cookies: Speicherung Ihrer Einstellungen

Sie können Ihren Browser so konfigurieren, dass Cookies abgelehnt werden, oder unser Einwilligungs-Banner verwenden, um Ihre Präferenzen anzupassen.`,
        },
        {
          title: '6. Haftung',
          content: `Nexia Digital ist bestrebt, auf der Website nexia-digital.com möglichst präzise Informationen bereitzustellen. Wir können jedoch nicht für Auslassungen, Ungenauigkeiten oder Mängel bei der Aktualisierung verantwortlich gemacht werden, weder durch uns noch durch Dritte.

Nexia Digital haftet nicht für direkte oder indirekte Schäden, die durch den Zugriff auf die Website oder die Nutzung der dort dargestellten Informationen entstehen.`,
        },
        {
          title: '7. Hyperlinks',
          content: `Die Website kann Links zu anderen Websites enthalten. Nexia Digital ist nicht verantwortlich für die Inhalte dieser Drittseiten und kann nicht für Schäden oder Nachteile haftbar gemacht werden, die aus deren Nutzung entstehen.`,
        },
        {
          title: '8. Anwendbares Recht',
          content: `Das vorliegende Impressum unterliegt dem geltenden Recht des Sitzlandes des Anbieters. Bei Streitigkeiten sind die Gerichte am Sitz von Nexia Digital zuständig.

Fragen zum vorliegenden Impressum können gerichtet werden an: contact@nexia-digital.net`,
        },
      ],
    },

    projectDetail: {
      seoFallback: 'Entdecken Sie das Projekt {title} von Nexia Digital.',
      breadcrumb: 'Portfolio',
      visitSite: 'Website besuchen',
      descriptionTitle: 'Projektbeschreibung',
      galleryTitle: 'Projektgalerie',
      visualAlt: 'Visual',
      challengesTitle: 'Herausforderungen & Lösungen',
      infoTitle: 'Projektinformationen',
      infoClient: 'Kunde',
      infoCategory: 'Kategorie',
      infoDuration: 'Dauer',
      infoYear: 'Jahr',
      infoTech: 'Technologien',
      ctaTitle: 'Ein ähnliches Projekt?',
      ctaDesc: 'Lassen Sie uns über Ihr Projekt sprechen und gemeinsam Ihren digitalen Erfolg gestalten.',
      ctaBtn: 'Angebot anfordern',
      previewAlt: 'Vorschau',
    },

    connect: {
      seoTitle: 'Verbinden wir uns — Nexia Digital',
      seoDesc: 'Entdecken Sie Nexia Digital, folgen Sie uns auf LinkedIn und melden Sie sich an, um Partner oder Kunde zu werden.',

      heroEyebrow: 'Verbinden wir uns',
      heroTitlePre: 'Willkommen bei',
      heroTitleEm: 'Nexia Digital',
      heroSubtitleHtml: 'Eine ganzheitliche Digitalagentur — <strong>Web, Branding, Marketing, KI</strong> und mehr. Wir begleiten Unternehmen in ihrer digitalen Transformation mit Strategie, Kreativität und Engagement. Ob künftiger Kunde oder künftiger Geschäftsvermittler — diese Seite ist für Sie gemacht.',
      ctaLeads: 'Hinterlassen Sie uns Ihre Kontaktdaten',
      ctaLinkedin: 'Folgen Sie uns auf LinkedIn',

      linkedinEyebrow: '— Bleiben wir in Kontakt',
      linkedinTitlePre: 'Folgen Sie uns auf',
      linkedinTitleEm: 'LinkedIn',
      linkedinDesc: 'News, laufende Projekte, Digital-Strategie-Tipps und Partnerschafts-Chancen — alles läuft über unser LinkedIn. Vernetzen Sie sich, um nichts zu verpassen.',
      linkedinCta: 'Unserem Netzwerk beitreten',

      docsEyebrow: '— Für Geschäftsvermittler',
      docsTitlePre: 'Dokumente',
      docsTitleEm: 'zum Herunterladen',
      docsDesc: 'Sie möchten uns Ihrem Netzwerk empfehlen und Provisionen erhalten? Sehen Sie sich unser komplettes Kit und unseren Partnervertrag an.',
      doc1Title: 'Vermittler-Kit',
      doc1Desc: 'Alles, was Sie wissen müssen, um uns zu empfehlen und Ihre Provisionen zu erhalten.',
      doc2Title: 'Partnervertrag',
      doc2Desc: 'Der detaillierte Vermittlervertrag, bereit zur Unterschrift.',
      docDownload: 'Herunterladen',
      docSoon: 'Bald verfügbar',

      formEyebrow: '— Bleiben wir verbunden',
      formTitlePre: 'Hinterlassen Sie Ihre',
      formTitleEm: 'Kontaktdaten',
      formDescHtml: 'Ob Sie an unseren Leistungen oder an unserem Vermittlerprogramm interessiert sind — füllen Sie dieses Formular aus, wir melden uns innerhalb von <strong>24 h</strong>.',
      perk1: 'Schnelle Antwort in 24 h',
      perk2: 'Unverbindlich',
      perk3: 'Ihre Daten bleiben vertraulich',

      successTitle: 'Danke!',
      successText: 'Ihre Anfrage wurde erfolgreich registriert.\nWir melden uns bald bei Ihnen.',
      sendAnother: 'Eine weitere Anfrage senden',

      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      notes: 'Notiz',
      optional: '(optional)',
      phFirstName: 'Jan',
      phLastName: 'Müller',
      phEmail: 'jan.mueller@email.de',
      phPhone: '+49 151 23456789',
      phNotes: 'Erzählen Sie uns in wenigen Worten von Ihrem Projekt, Ihrem Interesse oder wie Sie uns gefunden haben…',
      submit: 'Anfrage senden',
      submitting: 'Wird gesendet…',
      legalHtml: 'Mit dem Absenden dieses Formulars stimmen Sie der Verarbeitung Ihrer Daten durch Nexia Digital ausschließlich zu Kontaktzwecken zu.',
      legalLink: 'Mehr erfahren',

      toastReq: 'Vorname, Nachname und E-Mail sind erforderlich.',
      toastEmail: 'Ungültige E-Mail.',
      toastErr: 'Ein Fehler ist aufgetreten. Bitte erneut versuchen oder direkt schreiben.',
      toastSuccess: 'Danke! Wir melden uns bald bei Ihnen. 🎉',

      pdfEyebrow: 'Unser Portfolio · 2026',
      pdfTitlePre: 'Entdecken Sie unsere',
      pdfTitleEm: 'vollständige Präsentation',
      pdfDesc: 'Ein umfassendes Dokument, das zeigt, wer wir sind, unsere Expertise und unsere schönsten Realisierungen in Branding, Web-Entwicklung, Print und Social Media. Online ansehen oder herunterladen zum Teilen.',
      pdfCta1: 'Präsentation ansehen',
      pdfCta2: 'PDF herunterladen',
      pdfBadge: 'Portfolio PDF',
    },

    devis: {
      seoTitle: 'Angebot Digitalagentur Paris - Web-Preise in 24h | Nexia',
      seoDesc: 'Erhalten Sie Ihr kostenloses unverbindliches Angebot bei Nexia Digital. Digitalagentur spezialisiert auf Web-Entwicklung, SEO, Design und Marketing.',

      heroEyebrow: 'Kostenloses Angebot',
      heroTitlePre: 'Starten wir Ihr',
      heroTitleEm: 'Projekt gemeinsam',
      heroDesc: 'Füllen Sie dieses Formular aus und erhalten Sie ein individuelles kostenloses Angebot in weniger als 24 Stunden.',

      step1Label: 'Leistungen',
      step2Label: 'Details',
      step3Label: 'Informationen',

      step1Title: 'Welche Leistungen interessieren Sie?',
      step1Sub: 'Wählen Sie eine oder mehrere Leistungen (Mehrfachauswahl möglich)',
      step2Title: 'Details pro Leistung',
      step2Sub: 'Geben Sie uns mehr Kontext zu Ihren Anforderungen',
      step3Title: 'Ihre Kontaktdaten',
      step3Sub: 'Um Ihnen Ihr individuelles Angebot zuzusenden',

      continue: 'Weiter',
      back: '← Zurück',
      submitting: 'Wird gesendet...',
      submit: 'Anfrage senden',
      selectAtLeast: 'Wählen Sie mindestens eine Leistung aus.',
      requiredNameEmail: 'Name und E-Mail erforderlich.',
      submitSuccess: 'Anfrage gesendet! Wir melden uns innerhalb von 24h.',
      submitError: 'Fehler beim Senden.',

      selectPh: '— Auswählen —',
      budgetLabel: 'Geschätztes Budget',
      timelineLabel: 'Gewünschter Zeitrahmen',
      descriptionLabel: 'Projektbeschreibung',
      descriptionPh: 'Beschreiben Sie Ihr Projekt, Ihre Ziele, Ihre Zielgruppe und alles, was uns hilft, Ihren Bedarf besser zu verstehen...',

      nameLabel: 'Vollständiger Name *',
      namePh: 'Ihr Vor- und Nachname',
      emailLabel: 'Geschäftliche E-Mail *',
      emailPh: 'ihre@email.com',
      phoneLabel: 'Telefon',
      phonePh: '+49 151 XX XX XX XX',
      companyLabel: 'Unternehmen / Marke',
      companyPh: 'Name Ihres Unternehmens',

      summaryTitle: 'Zusammenfassung Ihrer Anfrage',
      summaryBudget: 'Budget:',
      summaryTimeline: 'Zeitrahmen:',

      successTitle: 'Anfrage gesendet!',
      successTextHtml: 'Danke <strong>{name}</strong>! Wir haben Ihre Angebotsanfrage erhalten. Unser Team meldet sich innerhalb von <strong>24 Arbeitsstunden</strong> bei Ihnen.',
      successHome: 'Zurück zur Startseite',
      successPortfolio: 'Unser Portfolio ansehen',

      budgets: ['< 1.000 €', '1.000 – 5.000 €', '5.000 – 15.000 €', '15.000 – 30.000 €', '30.000+ €', 'Gemeinsam festlegen'],
      timelines: ['Dringend (< 1 Monat)', '1 bis 3 Monate', '3 bis 6 Monate', '6 Monate+', 'Flexibel'],

      services: {
        web: {
          label: 'Web- & Mobile-Entwicklung',
          fields: {
            webType: { label: 'Projekttyp', options: ['Showcase-Website', 'E-Commerce-Website', 'Web-Anwendung', 'Mobile App', 'PWA'] },
            webTech: { label: 'Bevorzugte Technologien', placeholder: 'React, WordPress, Flutter...' },
            webPages: { label: 'Ungefähre Seitenzahl', placeholder: 'z. B. 10' },
          },
        },
        design: {
          label: 'Grafik & Design',
          fields: {
            designType: { label: 'Design-Typ', options: ['Logo & visuelle Identität', 'Brand Guide', 'UI/UX-Design', 'Print-Medien', 'Verpackung', 'Infografiken'] },
            designFiles: { label: 'Gewünschte Quelldateien', placeholder: 'AI, PSD, Figma...' },
          },
        },
        social: {
          label: 'Community Management',
          fields: {
            socialPlatforms: { label: 'Soziale Netzwerke', placeholder: 'Facebook, Instagram, LinkedIn...' },
            socialFrequency: { label: 'Gewünschte Posting-Frequenz', options: ['3 Posts/Woche', '5 Posts/Woche', '7 Posts/Woche', 'Noch festzulegen'] },
            socialBudget: { label: 'Monatliches Werbebudget (€)', placeholder: 'z. B. 500' },
          },
        },
        video: {
          label: 'Audiovisuell & Motion Design',
          fields: {
            videoType: { label: 'Content-Typ', options: ['Corporate-Video', 'Werbespot', 'Motion Graphics', 'Explainer Video', 'Reels & Shorts', 'Drohne'] },
            videoDuration: { label: 'Ungefähre Dauer', placeholder: 'z. B. 1-2 Minuten' },
          },
        },
        marketing: {
          label: 'Digitales Marketing & Werbung',
          fields: {
            mktChannels: { label: 'Marketing-Kanäle', placeholder: 'SEO, Google Ads, Meta Ads, E-Mail...' },
            mktBudget: { label: 'Monatliches Werbebudget (€)', placeholder: 'z. B. 1000' },
            mktGoal: { label: 'Hauptziel', options: ['Bekanntheit', 'Lead-Generierung', 'Online-Verkäufe', 'Website-Traffic', 'Kundenbindung'] },
          },
        },
        consulting: {
          label: 'Strategie & Beratung',
          fields: {
            consultingNeed: { label: 'Hauptbedarf', options: ['Digital-Audit', 'Markenstrategie', 'Kommunikationsplan', 'Schulung', 'Digitale Transformation'] },
          },
        },
        ia: {
          label: 'Maßgeschneiderte KI-Lösungen',
          fields: {
            iaType: { label: 'Art der KI-Lösung', options: ['KI-Conversational-Agent', 'Fortgeschrittener KI-Chatbot', 'KI-Automatisierung & CRM', 'Prädiktive Analytik (ML)', 'KI-Marketing', 'Andere / Kombination'] },
            iaIntegration: { label: 'Gewünschte Integrationen', placeholder: 'CRM, Website, WhatsApp, Slack...' },
            iaObjectif: { label: 'Hauptziel', options: ['Kundensupport automatisieren', 'Qualifizierte Leads generieren', 'Interne Aufgaben automatisieren', 'Daten / Prognosen analysieren', 'Content automatisch erstellen', 'Andere'] },
          },
        },
        'seo-sea': {
          label: 'SEO & SEA',
          fields: {
            seoSeaType: { label: 'Art der Leistung', options: ['Nur SEO', 'Nur SEA', 'SEO + SEA kombiniert', 'SEO-Audit', 'Lokales SEO (Google Business)'] },
            seoSeaMotsCles: { label: 'Ziel-Keywords', placeholder: 'z. B. Umzugsagentur Berlin, Scrabble Deutsch...' },
            seoSeaBudget: { label: 'Monatliches Werbebudget (€)', placeholder: 'z. B. 500' },
            seoSeaObjectif: { label: 'Hauptziel', options: ['Leads generieren', 'Traffic steigern', 'Lokale Sichtbarkeit', 'Online-Verkäufe', 'Markenbekanntheit'] },
          },
        },
      },
    },

    apporteursPage: {
      seoTitle: 'Geschäftsvermittler werden | Partnerprogramm Nexia Digital',
      seoDesc: 'Treten Sie dem Geschäftsvermittler-Programm von Nexia Digital bei: 12% Basisprovision, 15% ab dem 4. vermittelten Kunden pro Jahr. Auszahlung in 30 Tagen.',
      seoKeywords: 'Geschäftsvermittler, Partnerschaft, Provision, Partnerprogramm, Digitalagentur, Nexia Digital, Business Developer, Freelancer',
      ogTitle: 'Geschäftsvermittler werden | Nexia Digital',
      ogDesc: 'Geschäftsvermittler-Programm Nexia Digital: 12% Provision, 15% ab dem 4. Kunden, Auszahlung in 30 Tagen, 12 Monate Tracking.',

      heroEyebrow: 'Partnerprogramm',
      heroTitleLine1: 'Empfehlen Sie unsere Dienste.',
      heroTitleEm: 'Bis zu 15%',
      heroTitleAfter: 'Provision pro unterzeichnetem Kunden.',
      heroDescHtml: 'Nexia Digital sucht selbstständige Geschäftsvermittler. Sie stellen uns ein Unternehmen vor, das eine Website, maßgeschneiderte Entwicklung, SEO, Design, eine KI-Lösung oder eine digitale Strategie benötigt — wir kümmern uns um den Rest. Sie erhalten <strong>12% Provision</strong> auf jeden abgeschlossenen Auftrag und <strong>15% ab dem 4. vermittelten Kunden pro Jahr</strong>.',
      heroCtaPrimary: 'Geschäftsvermittler werden',
      heroCtaSecondary: 'So funktioniert es',

      stats: [
        { num: '12→15', suffix: '%', label: 'gestaffelte Provision auf den eingenommenen Netto-Umsatz — 12% Basis, 15% ab dem 4. Kunden' },
        { num: '30', suffix: ' Tage', label: 'maximale Auszahlungsfrist Ihrer Provision nach Kundenzahlung' },
        { num: '12', suffix: ' Monate', label: 'Provisionierung auf alle Verträge, die mit Ihrem vermittelten Kunden unterzeichnet werden' },
      ],

      stepsEyebrow: 'So funktioniert es',
      stepsTitlePre: 'Eine',
      stepsTitleEm: 'einfache',
      stepsTitlePost: ', transparente und strukturierte Partnerschaft.',
      stepsLede: 'Keine Quote, keine Ergebnispflicht, keine Zeitverpflichtung. Sie stellen vor, wenn sich die Gelegenheit ergibt — wir kümmern uns um Vertrieb und Leistung.',
      stepWord: 'Schritt',
      steps: [
        { n: '01', title: 'Sie bewerben sich', desc: 'Sie füllen das untenstehende Formular aus. Wir prüfen Ihr Profil innerhalb von 5 Werktagen.' },
        { n: '02', title: 'Wir unterzeichnen den Vertrag', desc: 'Ein klarer und fairer Vermittlungsvertrag ohne Exklusivität wird zwischen uns aufgesetzt.' },
        { n: '03', title: 'Sie stellen uns vor', desc: 'Sobald sich in Ihrem Netzwerk eine Gelegenheit ergibt, übermitteln Sie uns den qualifizierten Kontakt.' },
        { n: '04', title: 'Sie erhalten Ihre Provision', desc: 'Sobald der Auftrag fakturiert und bezahlt ist, erhalten Sie Ihre Provision innerhalb von 30 Tagen.' },
      ],

      commissionEyebrow: 'Die Vergütung',
      commissionTitlePre: 'Eine',
      commissionTitleEm: 'gestaffelte',
      commissionTitlePost: ' Provision, schnell bezahlt, ohne Überraschungen.',
      commissionTierDefaultLabel: 'Standard',
      commissionTierDefaultDesc: 'auf jeden abgeschlossenen Auftrag',
      commissionArrowLabel: 'Treuebonus',
      commissionTierBonusLabel: 'Ab dem 4. Kunden',
      commissionTierBonusDesc: 'pro Jahr vermittelt',
      commissionCaptionHtml: 'Provision berechnet auf den fakturierten und eingenommenen Netto-Umsatz, <strong>ohne Limit</strong>.',
      commissionPoints: [
        { title: 'Grundsatz: 12%', desc: 'Sie erhalten 12% vom eingenommenen Netto-Umsatz auf jeden abgeschlossenen Auftrag — ohne Limit, egal ob 1.000 € oder 50.000 €.' },
        { title: 'Treuebonus: 15%', desc: 'Ab dem 4. im Jahr vermittelten Kunden steigt Ihr Satz automatisch auf 15% — ein Vorteil, der Ihre Konstanz belohnt.' },
        { title: 'Auszahlung in 30 Tagen', desc: 'Sobald Nexia Digital die Kundenrechnung eingenommen hat, wird Ihre Provision innerhalb von 30 Tagen mit transparenter Nachverfolgung überwiesen.' },
        { title: '12 Monate Tracking', desc: 'Vertragserweiterungen, Verlängerungen und Zusatzleistungen Ihres Kunden werden 12 Monate lang provisioniert.' },
      ],

      servicesEyebrow: 'Was Sie empfehlen können — Klassische Digital-Sparte',
      servicesTitlePre: 'Unsere',
      servicesTitleEm: 'digitalen',
      servicesTitlePost: ' Leistungen.',
      servicesLedeHtml: 'Jeder Bedarf rund um Web oder Online-Sichtbarkeit ist berechtigt. Im Zweifelsfall stellen Sie uns vor: wir qualifizieren gemeinsam. <strong>→ Neu: wir bieten auch KI-Automatisierung und Conversational Agents an (siehe unten).</strong>',
      servicesClassic: [
        { tag: 'Erstellung', title: 'Websites', desc: 'Visitenkarten-Websites, E-Commerce-Sites, komplette Relaunches, performante Landingpages.' },
        { tag: 'Sichtbarkeit', title: 'SEO-Optimierung', desc: 'Audit, Content-Strategie, technische Optimierung, Linkbuilding und Positions-Tracking.' },
        { tag: 'Akquise', title: 'Digital-Marketing', desc: 'Google Ads, Meta Ads, Lead-Generierungs-Kampagnen, Social-Media-Strategien.' },
        { tag: 'Beratung', title: 'Digitale Strategie', desc: 'Audit, Begleitung und maßgeschneiderte Aktionspläne für KMU und Selbstständige.' },
        { tag: 'Identität', title: 'Grafik & Branding', desc: 'Logo, Corporate Identity, Styleguide, Print- und digitale Kommunikationsmittel.' },
        { tag: 'Wartung', title: 'Betreuung & Hosting', desc: 'Hosting, technische Wartung, Backups, Sicherheits-Updates.' },
      ],

      aiBadge: '★ Neue Aktivität',
      aiTitleLine1Pre: 'Automatisierung &',
      aiTitleLine1Em: 'KI-Agenten',
      aiTitleLine1Post: '.',
      aiTitleLine2: 'Eine neue Sparte mit großem Potenzial.',
      aiLedeHtml: 'Nexia Digital erweitert sein Angebot um <strong>No-Code-Automatisierung (n8n)</strong> und <strong>Conversational AI Agents</strong>. Ein boomender Markt, Kundenbudgets von <strong class="text-accent2">800 € bis 20.000 €</strong> pro Auftrag und <strong>dieselbe Provisionsstaffel</strong> für Sie (12%, dann 15% ab dem 4. Kunden). Hier sind die 4 Leistungsfamilien, die Sie empfehlen können.',
      aiCardsCiblesLabel: 'Zielgruppen',
      aiCardsBudgetLabel: 'Kundenbudget',
      aiCards: [
        {
          letter: 'Kategorie A',
          title: 'Conversational AI Agents',
          items: [
            'Multichannel-Kundensupport-Chatbot (WhatsApp + Website)',
            'Interner KI-Assistent auf Dokumentenbasis (RAG)',
            'Voicebot zur Lead-Qualifizierung (Vapi, Retell)',
            'Autonomer Multi-Tool-Agent (Recherche, Scraping, Synthese)',
          ],
          cibles: 'KMU im E-Commerce, Scale-ups, Immobilienagenturen, Arztpraxen',
          budget: '2.500 € – 20.000 €',
        },
        {
          letter: 'Kategorie B',
          title: 'Marketing- & Sales-Automatisierung',
          items: [
            'Lead-Scoring & automatisierte CRM-Anreicherung',
            'Personalisiertes KI-Cold-Outreach (E-Mail + LinkedIn)',
            'Content-Generierungs-Pipeline (Blog, Social)',
            'LinkedIn-Scraping + KI-Analyse + Alerting',
          ],
          cibles: 'B2B-SaaS, Growth-Agenturen, Personalvermittler',
          budget: '1.200 € – 7.000 €',
        },
        {
          letter: 'Kategorie C',
          title: 'Interne Unternehmens-Workflows',
          items: [
            'Automatisiertes HR-Onboarding (Signatur, Konten, Zugänge)',
            'Automatisches Reporting aus mehreren Quellen ohne Power BI',
            'KI-gestütztes Support-Ticket-Triage',
            'SaaS-Synchronisierung (Notion ↔ Airtable ↔ HubSpot)',
          ],
          cibles: 'Tech-Scale-ups, Dienstleistungs-KMU, Digitalagenturen',
          budget: '800 € – 9.000 €',
        },
        {
          letter: 'Kategorie D',
          title: 'Daten- & API-Integrationen',
          items: [
            'Anbindung von Legacy-ERP an moderne Stacks',
            'OCR + KI-Pipelines für Rechnungen und Dokumente',
            'Maßgeschneiderte Webhook-Middleware zwischen Anwendungen',
            'Individuelle API-Konnektoren',
          ],
          cibles: 'Industrie-KMU, Steuerberatungen, SaaS',
          budget: '1.000 € – 15.000 €',
        },
      ],
      aiNoteHtml: '<strong>Zum Merken:</strong> jeder Entscheider, der sagt „wir verlieren zu viel Zeit mit manuellen Aufgaben", „der Kundensupport ist zu teuer", „wir wollen einen internen KI-Assistenten", „unser CRM wird nicht genutzt" oder „wir müssen unsere Tools verbinden", ist ein qualifizierter Lead. Stellen Sie ihn vor — wir kümmern uns um die technische Qualifizierung.',

      profileEyebrow: 'Gesuchtes Profil',
      profileTitlePre: 'Wer kann',
      profileTitleEm: 'Vermittler',
      profileTitlePost: ' werden?',
      profileDesc: 'Unser Programm ist offen für jede Person, die unsere Dienste professionell empfehlen kann — ohne Statusbeschränkung.',
      profileItems: [
        'Selbstständige und Freelancer mit Kontakt zu Unternehmensleitern',
        'Berater, Coaches, Steuerberater, Anwälte, Kommunikationsagenturen',
        'Vertriebler und B2B-Networking-Profis',
        'Führungskräfte und Unternehmer mit aktivem beruflichem Netzwerk',
        'Jede Person, die eine Provision in Rechnung stellen kann (mind. Kleinunternehmer-Status)',
      ],

      formInfoTitle: 'Treten Sie dem Programm bei',
      formInfoLead: 'Füllen Sie dieses Formular aus — wir melden uns innerhalb von 5 Werktagen bei Ihnen mit einem Vertragsvorschlag und einem Briefing-Termin.',
      formInfoPoints: [
        '12% Basisprovision, 15% ab dem 4. Kunden/Jahr',
        'Keine Anmeldegebühr, keine Verpflichtung',
        'Auszahlung in 30 Tagen nach Kundenzahlung',
        '12 Monate Tracking Ihrer Vermittlungen',
        'Persönlicher Ansprechpartner zur Lead-Qualifizierung',
      ],
      formContactTitle: 'Eine Frage?',

      successTitle: 'Vielen Dank für Ihre Bewerbung!',
      successDesc: 'Ihre Anfrage wurde erfolgreich registriert. Unser Partnerteam wird Sie innerhalb von 5 Werktagen kontaktieren, um Ihre Aktivierung abzuschließen und Ihnen einen Vertragsvorschlag zu übermitteln.',
      successCta: 'Weiteres Profil anmelden',

      formTitle: 'Bewerbungsformular',
      formSub: 'Füllen Sie dieses Formular in 2 Minuten aus. Alle mit * markierten Felder sind Pflichtfelder.',
      formLabelName: 'Vollständiger Name *',
      formPhName: 'Z. B.: Jan Schmidt',
      formLabelEmail: 'E-Mail *',
      formPhEmail: 'ihre@email.de',
      formLabelPhone: 'Telefon *',
      formPhPhone: '+49 X XX XX XX XX',
      formLabelCity: 'Stadt',
      formPhCity: 'Berlin, München, Wien…',
      formLabelProfile: 'Profil *',
      formProfilePlaceholder: '— Profil wählen —',
      formLabelCompany: 'Unternehmen / Organisation',
      formPhCompany: 'Optional',
      formLabelNetwork: 'Größe Ihres beruflichen Netzwerks',
      formNetworkPlaceholder: '— Auswählen —',
      formLabelServices: 'Leistungen, die Sie interessieren',
      formLabelMotivation: 'Ihr Werdegang in wenigen Zeilen',
      formPhMotivation: 'Haupttätigkeit, Typ der Leads, die Sie uns vorstellen können, Motivation…',
      formAcceptTerms: 'Ich akzeptiere die Bedingungen des Geschäftsvermittler-Programms und erlaube Nexia Digital, mich bezüglich meiner Anmeldung zu kontaktieren.',
      formSubmit: 'Bewerbung senden',
      formSubmitting: 'Wird gesendet...',
      profiles: [
        'Selbstständig / Freelancer',
        'Berater / Coach',
        'Unternehmer',
        'Vertriebler / Business Developer',
        'Partner-Agentur',
        'Student / Praktikant',
        'Sonstiges',
      ],
      networkSizes: [
        '1 – 10 Kontakte',
        '10 – 50 Kontakte',
        '50 – 200 Kontakte',
        '200 – 1.000 Kontakte',
        'Mehr als 1.000 Kontakte',
      ],
      servicesInterest: [
        'Web- & Mobile-Entwicklung',
        'Grafik & Design',
        'Community Management',
        'Audiovisuelles & Motion Design',
        'Digital-Marketing & Werbung',
        'Strategie & Consulting',
        'Maßgeschneiderte KI-Lösungen',
        'SEO & SEA',
      ],
      toastRequired: 'Bitte füllen Sie alle Pflichtfelder aus.',
      toastTerms: 'Sie müssen die Bedingungen des Programms akzeptieren.',
      toastSuccess: 'Anmeldung gesendet! Unser Team meldet sich innerhalb von 48 Stunden bei Ihnen.',
      toastError: 'Fehler beim Senden. Bitte erneut versuchen.',

      faqEyebrow: 'Ihre Fragen',
      faqTitlePre: 'Alles, was Sie',
      faqTitleEm: 'wissen müssen',
      faqTitlePost: '.',
      faqIntro: 'Eine Frage, die hier nicht aufgeführt ist? Unser Partnerteam antwortet Ihnen direkt.',
      faq: [
        {
          q: 'Muss ich ein Unternehmen besitzen, um Vermittler zu werden?',
          a: 'Ja. Um eine rechtsgültige Provision zu erhalten, müssen Sie uns Rechnungen ausstellen können. Der einfachste Status ist der Kleinunternehmer, aber GmbH, UG, Einzelunternehmer oder Arbeitnehmerüberlassung sind ebenfalls möglich.',
        },
        {
          q: 'Gibt es eine Mindestanzahl an zu vermittelnden Leads?',
          a: 'Nein. Keine Mengenpflicht, keine Quote, keine Zeitverpflichtung. Sie stellen vor, wenn sich die Gelegenheit in Ihrem Netzwerk natürlich ergibt.',
        },
        {
          q: 'Woher wissen Sie, dass ein Lead von mir stammt?',
          a: 'Jeder Lead wird ab der Übermittlung per E-Mail oder über das dafür vorgesehene Formular nachverfolgt. Die Erstvermittlung ist Ihnen vertraglich für die gesamte Vertragslaufzeit garantiert.',
        },
        {
          q: 'Wann genau wird meine Provision ausgezahlt?',
          a: 'Die Provision ist nach tatsächlichem Zahlungseingang der Rechnung bei Nexia Digital fällig. Sie stellen uns dann eine Provisionsrechnung aus, und die Überweisung erfolgt innerhalb von maximal 30 Tagen.',
        },
        {
          q: 'Wie funktioniert der Wechsel von 12% auf 15% ab dem 4. Kunden?',
          a: 'Ihre Provision beträgt 12% auf die ersten 3 Kunden, die Sie uns im Kalenderjahr vermitteln. Ab dem 4. unterzeichneten Kunden im selben Jahr steigt Ihr Satz automatisch auf 15% — für diesen Auftrag und alle weiteren bis Jahresende. Der Zähler wird jedes Jahr am 1. Januar zurückgesetzt. Wichtig: nur Kunden, die zu einer Unterzeichnung und Zahlung geführt haben, zählen.',
        },
        {
          q: 'Ist der Vertrag exklusiv?',
          a: 'Nein. Sie können jeder anderen beruflichen Tätigkeit nachgehen oder mit anderen Dienstleistern zusammenarbeiten — ausgenommen direkt konkurrierende Digitalagenturen für die von Ihnen identifizierten Leads.',
        },
        {
          q: 'Werden die KI-Automatisierungs-Leistungen genauso provisioniert?',
          a: 'Ja, zu 100%. Die Aufträge unserer neuen Sparte (n8n-Automatisierung, KI-Agenten, Chatbots, Voicebots, Integrationen) werden zu den exakt gleichen Bedingungen provisioniert wie unsere klassischen Digital-Leistungen: 12% vom eingenommenen Netto-Umsatz (15% ab dem 4. vermittelten Kunden pro Jahr), Zahlung in 30 Tagen, 12 Monate Tracking. Die Kundenbudgets sind dort oft höher (bis zu 20.000 € pro Projekt).',
        },
        {
          q: 'Was passiert, wenn ich den Vertrag kündige?',
          a: 'Sie können jederzeit mit einer Frist von 15 Tagen kündigen. Provisionen auf bereits vermittelte Kunden bleiben für alle Leistungen geschuldet, die in den 12 Monaten nach der ersten Rechnung fakturiert werden.',
        },
      ],
    },

    questionnaire: {
      seoTitle: 'Kundenfragebogen — Nexia Digital',
      seoDesc: 'Füllen Sie unseren Kundenfragebogen aus, damit wir Ihr Projekt genau verstehen und Ihnen ein personalisiertes Angebot unterbreiten können.',

      heroEyebrow: 'Kundenfragebogen',
      heroTitleLine1: 'Erzählen Sie uns von',
      heroTitleEm: 'Ihrem Projekt',
      heroDesc: 'Beantworten Sie nur die für Sie relevanten Teile. Dieses Dokument ermöglicht es uns, Ihnen so schnell wie möglich ein personalisiertes Angebot zu unterbreiten.',

      stepsNav: [
        { label: 'Identität' },
        { label: 'Ziele' },
        { label: 'Website & Inhalt' },
        { label: 'Branding & SEO' },
        { label: 'KI & Netzwerke' },
        { label: 'Budget' },
      ],

      next: 'Weiter',
      back: '← Zurück',
      submit: 'Fragebogen senden',
      submitting: 'Wird gesendet...',

      toastStep1: 'Bitte geben Sie mindestens Ihren Namen und Ihre E-Mail-Adresse an.',
      toastRequired: 'Name und E-Mail erforderlich.',
      toastSuccess: 'Fragebogen gesendet! Wir melden uns in Kürze bei Ihnen.',
      toastError: 'Fehler beim Senden. Bitte erneut versuchen.',

      successTitle: 'Fragebogen gesendet!',
      successDescHtml: 'Danke <strong>{name}</strong>! Wir haben Ihren Fragebogen erhalten. Unser Team wird Ihre Bedürfnisse analysieren und sich in Kürze mit einem personalisierten Angebot bei Ihnen melden.',
      successHome: 'Zurück zur Startseite',
      successContact: 'Kontakt aufnehmen',

      // Step 1
      s1Title: '1. Allgemeine Informationen',
      s1NomClientLabel: 'Name des Kunden / Unternehmens *',
      s1NomClientPh: 'Ihr Name oder Name des Unternehmens',
      s1InterlocuteurLabel: 'Hauptansprechpartner',
      s1InterlocuteurPh: 'Vor- und Nachname',
      s1EmailLabel: 'E-Mail *',
      s1EmailPh: 'ihre@email.de',
      s1TelephoneLabel: 'Telefon',
      s1TelephonePh: '+49 XXX XX XX XX',

      s2Title: '2. Unternehmensidentität',
      s2NomLegalLabel: 'Offizieller Name (Handelsregister)',
      s2NomLegalPh: 'Offizieller Name des Unternehmens',
      s2SecteurLabel: 'Branche',
      s2SecteurPh: 'Z. B.: Gastronomie, Immobilien...',
      s2DateLabel: 'Gründungsdatum',
      s2DatePh: 'Z. B.: 2018',
      s2SloganLabel: 'Slogan / Hauptclaim',
      s2SloganPh: 'Ihr Claim',
      s2ValeursLabel: 'Ihre Werte',
      s2AutreValeurPh: 'Anderer Wert...',
      s2AnneesLabel: 'Jahre Erfahrung',
      s2AnneesPh: 'Z. B.: 10 Jahre',
      s2NombreClientsLabel: 'Anzahl der Kunden',
      s2NombreClientsPh: 'Z. B.: +500 Kunden',
      s2RealisationsLabel: 'Referenzen / herausragende Projekte',
      s2RealisationsPh: 'Beschreiben Sie Ihre wichtigsten Referenzen',
      s2VisuelsLabel: 'Verfügbare visuelle Materialien',

      // Step 2
      s3Title: '3. Projektziele',
      s3TypeProjetLabel: 'Projekttyp',
      s3AutreTypeProjetPh: 'Anderer Projekttyp...',
      s3ResultatLabel: 'Erwartetes Hauptergebnis',
      s3AutreResultatPh: 'Anderes erwartetes Ergebnis...',
      s3SuccesLabel: 'Wie sieht Erfolg für Sie in 6 Monaten aus?',
      s3SuccesPh: 'Beschreiben Sie Ihre Vision von Erfolg...',

      s4Title: '4. Zielgruppe & Positionierung',
      s4ClientsLabel: 'Ihre Wunschkunden',
      s4AutresCiblesPh: 'Andere Kundenart...',
      s4ZoneGeoLabel: 'Geografische Zielregion',
      s4ConcurrentsLabel: 'Ihre 3 wichtigsten Wettbewerber',
      s4ConcurrentsPh: 'Namen oder Websites Ihrer Wettbewerber',
      s4DifferentiationLabel: 'Was Sie von ihnen unterscheidet',
      s4DifferentiationPh: 'Ihre Wettbewerbsvorteile',
      s4TonLabel: 'Gewünschte Tonalität',

      // Step 3
      s5Title: '5. Website',
      s5SiteActuelLabel: 'Link zur aktuellen Website (falls vorhanden)',
      s5SiteActuelPh: 'https://...',
      s5NombrePagesLabel: 'Geschätzte Seitenzahl',
      s5NombrePagesPh: 'Z. B.: 5 Seiten',
      s5PagesLabel: 'Gewünschte Seiten',
      s5AutrePagePh: 'Andere Seite...',
      s5OptionsLabel: 'Zusatzoptionen',
      s5DelaiLabel: 'Gewünschter Zeitrahmen für den Launch',
      s5DelaiPh: 'Z. B.: 2 Monate, vor dem 1. Juli...',

      s6Title: '6. Inhalt & Texterstellung',
      s6TextesLabel: 'Texte',
      s6MediasLabel: 'Verfügbare Medien',
      s6TonRedactionLabel: 'Gewünschte Schreibtonalität',
      s6TonRedactionPh: 'Z. B.: professionell und zugänglich, dynamisch, formell...',

      // Step 4
      s7Title: '7. Branding & Styleguide',
      s7LogoLabel: 'Logo',
      s7CharteLabel: 'Styleguide',
      s7CouleursLabel: 'Aktuelle oder gewünschte Farben',
      s7CouleursPh: 'Z. B.: Marineblau, Gold, Weiß...',
      s7TypographiesLabel: 'Verwendete Schriftarten',
      s7TypographiesPh: 'Z. B.: Montserrat, Georgia...',
      s7AmbianceLabel: 'Gewünschte visuelle Stimmung',
      s7SitesLabel: '3 Websites, die Ihnen visuell gefallen (und warum)',
      s7Site1Ph: 'Website 1: URL und Grund',
      s7Site2Ph: 'Website 2: URL und Grund',
      s7Site3Ph: 'Website 3: URL und Grund',

      s8Title: '8. SEO — Suchmaschinenoptimierung',
      s8SituationLabel: 'Aktuelle Situation',
      s8ObjectifsLabel: 'SEO-Ziele',
      s8MotsClesLabel: 'Prioritäre Keywords',
      s8MotsClesPh: 'Z. B.: Webagentur Berlin, E-Commerce-Erstellung, SEO München...',

      // Step 5
      s9Title: '9. Automatisierung & Künstliche Intelligenz',
      s9Note: 'Kreuzen Sie die Funktionen an, die Sie interessieren — kein technisches Fachwissen erforderlich!',
      s9AutomatisationLabel: 'Automatisierung',
      s9SurSiteLabel: 'Auf der Website',
      s9IntegrationsLabel: 'Integration mit Ihren Tools',
      s9AutreIntegrationPh: 'Anderes Tool...',
      s9FamiliariteLabel: 'Vertrautheit mit KI',

      s10Title: '10. Social Media & Kommunikation',
      s10ReseauxLabel: 'Aktive Netzwerke',
      s10AutreReseauPh: 'Anderes Netzwerk...',
      s10BesoinsLabel: 'Bedürfnisse',
      s10FrequenceLabel: 'Gewünschte Veröffentlichungsfrequenz',
      s10FrequencePh: 'Z. B.: 3 Posts/Woche, täglich...',

      // Step 6
      s11Title: '11. Budget & Organisation',
      s11BudgetLabel: 'Gesamtbudget für das Projekt',
      s11DelaisLabel: 'Gewünschter Zeitrahmen',
      s11DelaisPh: 'Z. B.: in 3 Monaten, vor Sommer 2025...',
      s11InterlocuteurLabel: 'Hauptansprechpartner (Name + Kontakt)',
      s11InterlocuteurPh: 'Name und Kontaktdaten',
      s11ExperienceLabel: 'Erfahrung mit Agenturen',
      s11MauvaisesPh: 'Beschreiben Sie, was Sie vermeiden möchten...',

      s12Title: '12. Freiraum',
      s12Label: 'Fügen Sie hier alles hinzu, was nicht abgedeckt wurde und uns helfen würde, Sie besser zu betreuen',
      s12Ph: 'Ihre Anmerkungen, Fragen, ergänzende Informationen...',

      summaryTitle: 'Zusammenfassung Ihres Fragebogens',
      summaryClient: 'Kunde',
      summaryEmail: 'E-Mail',
      summarySecteur: 'Branche',
      summaryProjet: 'Projekt',
      summaryBudget: 'Budget',
      summaryDelai: 'Zeitrahmen',

      valeurs: ['Exzellenz & Servicequalität', 'Sorgfalt & Sicherheit', 'Reaktionsfähigkeit', 'Menschliche / emotionale Betreuung', 'Innovation'],
      visuels: ['Fotos des Teams', 'Fotos der Ausrüstung / Räumlichkeiten', 'Videos', 'Kundenstimmen', 'Keine — zu erstellen'],
      typeProjet: ['Erstellung einer neuen Website', 'Relaunch der bestehenden Website', 'Optimierung der aktuellen Website'],
      resultats: ['Leads / Angebote generieren', 'Google-Sichtbarkeit steigern', 'Bekanntheit / Branding stärken', 'Online-Verkauf', 'Aufgaben automatisieren'],
      cibles: ['Privatpersonen', 'Selbstständige / KMU', 'Großunternehmen'],
      zoneGeoOptions: ['Lokal / regional', 'National', 'International'],
      tons: ['Seriös / institutionell', 'Warm / menschlich', 'Premium / Luxus', 'Modern / dynamisch', 'Zugänglich / breitenwirksam'],
      pagesSouhaitees: ['Startseite', 'Über uns / Geschichte', 'Leistungen / Angebote', 'Referenzen / Portfolio', 'Kundenstimmen', 'Blog / Aktuelles', 'Kontakt', 'Online-Angebotsformular'],
      optionsSupp: ['Mehrsprachige Website', 'Kunden- / Mitgliederbereich', 'Online-Terminvereinbarung', 'Live-Chat', 'Domainname bereits vorhanden'],
      textesOptions: ['Ich habe bestehende Texte zur Wiederverwendung', 'Ich möchte, dass Nexia Digital die Inhalte verfasst', 'Mischung aus beidem'],
      medias: ['Professionelle Fotos', 'Private Fotos', 'Videos', 'Kundenstimmen', 'Keine — alles ist zu erstellen'],
      logoOptions: ['Bestehendes Logo — zufrieden', 'Bestehendes Logo — zu modernisieren', 'Kein Logo — zu erstellen'],
      charteOptions: ['Bestehender Styleguide einzuhalten', 'Kein Styleguide — zu erstellen'],
      ambiances: ['Schlicht / minimalistisch', 'Farbig / dynamisch', 'Modern / Tech', 'Elegant / Premium', 'Warm / menschlich'],
      situationSEO: ['Auf Google sichtbar', 'Wenig sichtbar', 'Keine Google-Präsenz', 'Google Business Profile vorhanden'],
      objectifsSEO: ['Auf lokalen Keywords erscheinen', 'Nationales SEO', 'Erstellung / Optimierung Google Business', 'Monatliche Leistungsüberwachung'],
      automatisation: ['Automatischer Angebotsversand', 'Automatische Kundennachfassungen', 'Automatisierte Terminvereinbarung', 'Automatische Zusammenfassung von Kundengesprächen', 'Content-Generierung (E-Mails, Posts, Datenblätter...)'],
      surSite: ['Chatbot / virtueller Assistent', 'Intelligentes Formular (Kunden-Vorqualifizierung)', 'Automatisierte FAQ'],
      integrations: ['CRM (HubSpot, Salesforce...)', 'Kalender / Google Calendar', 'E-Mail (Gmail, Outlook...)'],
      familiariteOptions: ['Anfänger — ich möchte mehr erfahren', 'Mittel — ich nutze bereits einige Tools', 'Fortgeschritten — ich habe konkrete Anforderungen'],
      reseaux: ['Instagram', 'Facebook', 'LinkedIn', 'TikTok', 'YouTube'],
      besoinsRS: ['Social-Media-Management', 'Erstellung visueller Inhalte', 'Newsletter', 'Werbekampagnen (Meta Ads, Google Ads)'],
      budgets: ['Weniger als 1.000 €', '1.000 € – 3.000 €', '3.000 € – 6.000 €', '6.000 € – 10.000 €', 'Mehr als 10.000 €', 'Gemeinsam zu definieren'],
      experienceOptions: ['Erste Zusammenarbeit mit einer Agentur', 'Positive frühere Erfahrungen', 'Schlechte Erfahrungen zu vermeiden'],
      experienceAvoid: 'Schlechte Erfahrungen zu vermeiden',
    },

    partners: {
      eyebrow: 'Geschäftsvermittler',
      titlePre: 'Empfehlen Sie unsere Dienste.',
      titleEm: 'Bis zu 15%',
      titlePost: 'Provision pro unterzeichnetem Kunden.',
      desc: 'Nexia Digital sucht selbstständige Geschäftsvermittler. Sie stellen uns ein Unternehmen vor, das eine Website, maßgeschneiderte Entwicklung, SEO, Design, KI-Lösungen oder eine digitale Strategie benötigt — wir kümmern uns um den Rest. 12% Grundprovision, 15% ab dem 4. vermittelten Kunden pro Jahr.',
      point1: '12% vom Netto-Umsatz, 15% ab dem 4. Kunden/Jahr',
      point2: 'Auszahlung innerhalb von 30 Tagen nach Kundenzahlung',
      point3: 'Keine Quote, keine Exklusivität, 12 Monate Tracking',
      ctaPrimary: 'Geschäftsvermittler werden',
      ctaSecondary: 'Eine Frage? Kontaktieren Sie uns',
      b1Title: '12% Basisprovision, kein Limit',
      b1Desc:  '12% Provision auf den eingenommenen Netto-Umsatz, unabhängig vom Auftragswert.',
      b2Title: '15% ab dem 4. Kunden',
      b2Desc:  'Treuebonus: Ihr Satz steigt ab dem 4. vermittelten Kunden im Jahr auf 15%.',
      b3Title: 'Zahlung in 30 Tagen',
      b3Desc:  'Sobald Nexia Digital die Kundenrechnung eingenommen hat, wird Ihre Provision überwiesen.',
      b4Title: '12 Monate Tracking',
      b4Desc:  'Vertragserweiterungen, Verlängerungen und Zusatzleistungen bleiben provisioniert.',
    },

    cta: {
      eyebrow: 'Bereit für den Take-off?',
      titlePre: 'Ihr Digitalprojekt verdient',
      titleEm: 'das beste Team',
      desc: 'Erhalten Sie ein kostenloses und personalisiertes Angebot in weniger als 24 Stunden. Unser Digital-Expertenteam analysiert Ihre Bedürfnisse und schlägt Ihnen eine maßgeschneiderte Strategie vor, um Ihre Ziele zu erreichen und Ihre Online-Sichtbarkeit zu steigern.',
      f1: 'Kostenloses Angebot, unverbindlich',
      f2: 'Antwort in weniger als 24h',
      f3: 'Persönliche Betreuung',
      ctaMain: 'Kostenloses Angebot anfordern',
      panelEyebrow: 'Garantierte Reaktionszeit',
      h1Title: 'Schnelle Lieferung', h1Sub: 'Termine zu 100% eingehalten',
      h2Title: '98% Zufriedenheit',   h2Sub: 'Kunden, die uns weiterempfehlen',
      h3Title: 'Innovation',           h3Sub: 'Modernste Technologien',
    },

    navbar: {
      home: 'Startseite',
      about: 'Über uns',
      services: 'Leistungen',
      portfolio: 'Portfolio',
      apporteurs: 'Vermittler',
      contact: 'Kontakt',
      cta: 'Angebot anfordern',
    },

    about: {
      heroEyebrow: 'Unsere Geschichte',
      heroTitlePre: 'Leidenschaftlich digital,',
      heroTitleEm: 'engagiert für Ihren Erfolg',
      heroDesc: 'Nexia Digital ist eine Kommunikationsagentur der neuen Generation mit Full-Service-Angebot. Unsere Mission: Unternehmen mit Kreativität, Expertise und messbaren Ergebnissen in ihrer digitalen Transformation zu begleiten.',
      heroCta1: 'Mit uns arbeiten',
      heroCta2: 'Unsere Projekte ansehen',
      missionTitle: 'Unsere Mission',
      missionText: 'Digitale Exzellenz demokratisieren, indem wir kreative und technologische Lösungen auf internationalem Niveau anbieten, zugänglich für Unternehmen jeder Größe. Wir verwandeln digitale Herausforderungen in Wachstumschancen.',
      missionP1: 'Maßgeschneiderte Strategien für jeden Kunden',
      missionP2: 'Modernste Technologien und Best Practices',
      missionP3: 'Messbare und transparente Ergebnisse',
      visionTitle: 'Unsere Vision',
      visionText: 'Die Referenz unter den Digitalagenturen in Nordafrika werden — anerkannt für kreative Exzellenz, technologische Expertise und konkrete Wirkung für unsere Kunden. Wir glauben an ein ethisches, inklusives und sinnstiftendes Digital.',
      visionP1: 'Führend in internationaler digitaler Innovation',
      visionP2: 'Expansion auf afrikanischen und europäischen Märkten',
      visionP3: 'Beitrag zur globalen digitalen Ausstrahlung',
      valuesTitle: 'Unsere Werte',
      valuesText: 'Exzellenz, Integrität, Kreativität und Partnerschaft sind die Säulen jeder Aktion von Nexia Digital. Wir liefern nicht nur Projekte — wir bauen nachhaltige Erfolge auf.',
      valuesP1: 'Kompromisslose Qualität bei jedem Deliverable',
      valuesP2: 'Volle Transparenz in unserer Kommunikation',
      valuesP3: 'Kontinuierliche Innovation und Technologie-Watch',
      processEyebrow: 'Unsere Methode',
      processTitlePre: 'Unser',
      processTitleEm: 'Arbeitsprozess',
      step1Title: 'Entdeckung & Briefing',
      step1Desc:  'Wir nehmen uns die Zeit, Ihr Projekt, Ihre Ziele und Ihre Zielgruppe zu verstehen. Ein vollständiges Briefing wird erstellt, um den Auftrag zu definieren.',
      step2Title: 'Strategie & Konzeption',
      step2Desc:  'Unser Team entwickelt eine maßgeschneiderte Strategie und schlägt kreative Konzepte vor, die zu Ihrer Markenidentität passen.',
      step3Title: 'Kreation & Entwicklung',
      step3Desc:  'Unsere Experten setzen um: Design, Entwicklung, Content-Produktion — jedes Deliverable wird mit Sorgfalt und Präzision umgesetzt.',
      step4Title: 'Validierung & Tests',
      step4Desc:  'Jeder Schritt wird mit Ihnen validiert. Wir führen rigorose Tests durch, um Qualität und Konformität jedes Deliverables sicherzustellen.',
      step5Title: 'Launch & Lieferung',
      step5Desc:  'Ihr Projekt geht online oder wird gemäß den vereinbarten Fristen geliefert. Wir sorgen für einen reibungslosen Launch.',
      step6Title: 'Tracking & Optimierung',
      step6Desc:  'Unsere Begleitung endet nicht mit der Lieferung. Wir analysieren die Performance und optimieren kontinuierlich, um Ihre Ergebnisse zu maximieren.',
      pdfEyebrow: 'Unser Portfolio · 2026',
      pdfTitlePre: 'Entdecken Sie unsere',
      pdfTitleEm: 'vollständige Präsentation',
      pdfDesc: 'Ein vollständiges Dokument, das zeigt, wer wir sind, unsere Expertise und unsere schönsten Realisierungen in Branding, Webentwicklung, Print-Medien und Social Media. Online ansehen oder herunterladen, um es zu teilen.',
      pdfCta1: 'Präsentation ansehen',
      pdfCta2: 'PDF herunterladen',
      pdfBadge: 'Portfolio PDF',
      questEyebrow: 'Sprechen wir über Ihr Projekt',
      questTitlePre: 'Bereit, das Abenteuer',
      questTitleEm: 'mit uns zu beginnen?',
      questDesc: 'Füllen Sie unseren Kundenfragebogen aus und erhalten Sie ein personalisiertes Angebot, das auf Ihre Bedürfnisse und Ihr Budget zugeschnitten ist.',
      questCta: 'Fragebogen ausfüllen',
    },

    footer: {
      tagline: 'Ihr vertrauensvoller Digital-Partner. Wir verwandeln Ihre Ideen in herausragende digitale Erlebnisse, um Ihre Marke in die Zukunft zu führen.',
      servicesTitle: 'Unsere Leistungen',
      navigationTitle: 'Navigation',
      contactTitle: 'Kontakt',
      navHome: 'Startseite',
      navAbout: 'Über uns',
      navPortfolio: 'Portfolio',
      navContact: 'Kontakt',
      navDevis: 'Angebot anfordern',
      navApporteurs: 'Geschäftsvermittler werden',
      rights: 'Alle Rechte vorbehalten.',
      legal: 'Impressum',
      madeWith: 'Erstellt mit',
      madeBy: 'von Nexia Digital',
      scrollTop: 'Nach oben',
      srvWeb: 'Web- & Mobile-Entwicklung',
      srvDesign: 'Grafik & Design',
      srvCommunity: 'Community Management',
      srvAudio: 'Audiovisuell & Motion Design',
      srvMarketing: 'Digitales Marketing',
      srvStrategy: 'Strategie & Beratung',
      srvIA: 'Maßgeschneiderte KI-Lösungen',
      srvSeo: 'SEO & SEA',
    },

    testimonials: {
      eyebrow: 'Kundenstimmen',
      titlePre: 'Was unsere',
      titleEm: 'Partner sagen',
      desc: 'Die Zufriedenheit unserer Kunden ist unsere beste Belohnung. Entdecken Sie die Erfahrungsberichte mit Nexia Digital.',
      verifiedF: 'Verifizierte Kundin',
      verifiedM: 'Verifizierter Kunde',
      reviewsCount: '{count} Bewertungen',
      seeOnTrustpilot: 'Auf Trustpilot ansehen',
      seeAllReviews: 'Alle Bewertungen auf Trustpilot ansehen',
      trust1: '100% Vertraulich',
      trust2: 'Nachhaltige Partnerschaften',
      trust3: 'Garantierter ROI',
      trust4: 'Support 7 Tage / Woche',
      role1: 'Präsident des Organisationskomitees der Scrabble-WM 2026',
      t1Title: 'Tunis 2026 – 54. Weltmeisterschaft des frankophonen Scrabbles',
      t1Text:  'Im Rahmen der Organisation der Weltmeisterschaft des frankophonen Scrabbles in Tunis im kommenden Juli haben wir die Agentur Nexia-Takt mit der Erstellung der Präsentations- und Partnerschaftsmappe sowie der Aktualisierung der WM-Website beauftragt. Professionalität und Verfügbarkeit haben zum Erfolg dieser Zusammenarbeit für diesen wichtigen Schritt geführt. Danke an alle Beteiligten für diese großartigen Arbeiten.',
      t2Title: 'Professionalität, die geleistete Arbeit…',
      t2Text:  'Zunächst einmal die mit Professionalität geleistete Arbeit, das ist großartig. Sie hören dem Kunden zu, sind reaktiv, wirklich verfügbar. Sie versuchen immer, eine Lösung zu finden, und schlagen dem Kunden das Beste vor. Ich fühlte mich gehört, sie waren sehr aufmerksam gegenüber meinen Erwartungen und haben das Pflichtenheft vollständig erfüllt. Ich werde diese Firma immer empfehlen, denn es ist sehr selten geworden, Unternehmen zu finden, die dem Kunden zuhören. Eine sehr schöne Erfahrung, und ich danke ihnen für die Zusammenarbeit.',
      t3Title: 'Ein effizientes und sehr professionelles Team',
      t3Text:  'Ein effizientes und sehr professionelles Team. Hält die Fristen ein und liefert qualitativ hochwertige Arbeit. 🙏🏽🙏🏽🙏🏽🙏🏽',
      t4Title: 'Website-Relaunch',
      t4Text:  'Wir haben die Agentur beauftragt, unsere Website der Weltmeisterschaft des frankophonen Scrabbles zu verbessern, die im Juli 2026 in Tunis stattfindet. Ihr Personal ist kompetent und sehr sympathisch. Unsere Kontakte waren sehr fruchtbar. Wir sind sehr zufrieden mit dem Ergebnis und empfehlen diese Agentur weiter.',
    },
  },
};
